import React from 'react';
import PageHeader from './PageHeader.js';
import CaseStudies from './CaseStudies.js';
import PrettyThings from './PrettyThings.js';
import About from './About.js';
import Contact from './Contact.js';
import ProjectViewer from './ProjectViewer.js';
import PrettyViewer from './PrettyViewer.js';
import './App.css';

import book_nation_header_img from './img/case_studies/book_nation/book_nation_header.png';
import fbtb_header_img from './img/case_studies/fbtb/fbtb_header.png';
import mira_mvp_thumb_header from './img/case_studies/mira_mvp/mira_mvp_t_header.png';

/*import 'https://cdnjs.cloudflare.com/ajax/libs/svg.js/3.0.16/svg.min.js';*/

const importAll = require =>
  require.keys().reduce((acc, next) => {
    acc[next.replace("./", "")] = require(next);
    return acc;
  }, {});

const Case_Images = importAll(
  require.context("./img/case_studies", true, /\.(png|jpe?g|svg|gif)$/)
);
/*
const Project_Images = importAll(
  require.context("./img/projects", false, /\.(png|jpe?g|svg|gif)$/)
);*/

const Pretty_Images = importAll(
  require.context("./img/pretty_things", true, /\.(png|jpe?g|svg|gif)$/)
);



////////////////////////////////////
// REACT APP FUNCTIONS /////////////
////////////////////////////////////



class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectIsOpen: false,
      currentPage: "home",
      currentProject: false,
      prettyIsOpen: false,
      previous_page: false,
      project_is_opening:false,
      projects: {...case_data, ...pretty_data }
    };
  }
  componentDidMount(){
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('scroll', this.checkPosition.bind(this));
    window.addEventListener('load', this.load_then_check_position.bind(this));
    this.checkPosition.bind(this);
    setup_titles();

    /*
    //check page URL for page assignment when page is loaded
    if(sections.hasOwnProperty(window.location.pathname.replace("/", ""))){
      console.log('valid page!!!');
      var elmnt = document.getElementById("Nav_wrapper");
      elmnt.scrollIntoView();
      this.setState({currentPage:window.location.pathname.replace("/", "")});
    }else if(Projects.hasOwnProperty(window.location.pathname.replace("/", ""))){
      console.log('valid project!!!');
      this.setState({currentProject:window.location.pathname.replace("/", ""), projectIsOpen:true});
      console.log(window.location.pathname.replace("/", ""));
    }
      
      //detect URL change
      window.addEventListener("popstate", function(e) {
        
        //if user navigates back to home
        if(window.location.pathname == "/"){
          var elmnt = document.getElementById("Nav_wrapper");
          elmnt.scrollIntoView();
          this.setState({currentPage:"About", projectIsOpen:true, currentProject:false},function(){checkPosition();});
        }

        //navigate to correct page
        console.log('url change');
        if(sections.hasOwnProperty(window.location.pathname.replace("/", ""))){
          console.log('valid page!!!');
          var elmnt = document.getElementById("Nav_wrapper");
          elmnt.scrollIntoView();
          this.setState({currentPage:window.location.pathname.replace("/", ""), projectIsOpen:true, currentProject:false},function(){checkPosition();});
        }else if(Projects.hasOwnProperty(window.location.pathname.replace("/", ""))){
          console.log('valid project!!!');
          this.setState({currentProject:window.location.pathname.replace("/", ""), projectIsOpen:true},function(){checkPosition();});
        }
      }.bind(this));*/
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.checkPosition);
    window.removeEventListener('load', this.load_then_check_position.bind(this));
  }
  handleScroll(e){

    console.log(window.scrollY);
    if(!this.state.projectIsOpen && !this.state.prettyIsOpen){

      var new_page = false;
                                                                                                                                                                                              
      if(window.scrollY > document.getElementById("contact").offsetTop-150){
        new_page = "contact";
      }else if(window.scrollY > document.getElementById("about").offsetTop-150){
        new_page = "about";
      }else if(window.scrollY > document.getElementById("pretty").offsetTop-150){
        new_page = "pretty";
      }else if(window.scrollY > document.getElementById("case").offsetTop-150){
        new_page = "case";
      }else{
        new_page = "home";
      }

      if(new_page != this.state.currentPage){
        this.setState({
          currentPage: new_page
        });
        setURL(new_page);
      }

    }

  }
  load_then_check_position(e){
    this.checkPosition(e);
    window.removeEventListener('load', this.load_then_check_position);
  }
  disableScroll(){
    document.getElementsByTagName('body')[0].classList.add('noScroll');
    document.getElementsByTagName('html')[0].classList.add('noScroll');
  }
  enableScroll(){
    document.getElementsByTagName('body')[0].classList.remove('noScroll');
    document.getElementsByTagName('html')[0].classList.remove('noScroll');
  }
  closeProject(e){
    this.changePage(this.state.previous_page,e, true);
    this.enableScroll();
  }
  changePage(new_page,e, dontScroll, viewer_type){
    if(new_page != this.state.currentPage){
      var projectIsOpen = false;
      var prettyIsOpen = false;
      var current_project = false;
      var previous_page = false;
      var project_is_opening = false;
      if(!main_pages.includes(new_page)){
        if(viewer_type){
          if(viewer_type == "case"){
            projectIsOpen = true;
          }else if(viewer_type == "pretty"){
            prettyIsOpen = true;
          }
        }
        current_project = new_page;
        previous_page = this.state.currentPage;
        project_is_opening = true;
        this.disableScroll();
      }
      setURL(new_page);
      this.setState({
        currentPage: new_page,
        projectIsOpen:projectIsOpen,
        prettyIsOpen:prettyIsOpen,
        currentProject:current_project,
        previous_page:previous_page,
        project_is_opening: project_is_opening
      },function(){
        if(!projectIsOpen && !dontScroll){
          var elmnt = document.getElementById(new_page);
          elmnt.scrollIntoView();
        }
      });
    }
  }
  checkPosition() {
    if(!this.state.projectIsOpen){
      var navbar = document.getElementById("nav");
      var navwrapper = document.getElementById("nav_wrapper");
      if(typeof(navbar) != 'undefined' && navbar != null){
        if(window.scrollY > navwrapper.offsetTop){
          navbar.classList.add("sticky");
        }else{
          navbar.classList.remove("sticky");
        }
      }

      var app_el = document.getElementById("App");
      if(typeof(app_el) != 'undefined' && app_el != null){
        if(window.scrollY > document.getElementById("home").offsetHeight-400){
          app_el.classList.add("scrolled");
        }else{
          app_el.classList.remove("scrolled");
        }
      } 

      elements = document.querySelectorAll('.hidden');
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var positionFromTop = elements[i].getBoundingClientRect().top;

        if (positionFromTop - windowHeight + 350 <= 0) {
          element.classList.add('fade-in-element');
          element.classList.remove('hidden');
        }
      }
    }
  }
  open_pretty(e){
    
  }
  project_is_done_opening(){
    this.setState({project_is_opening:false});
  }
  get_in_touch(e){
    if(this.state.projectIsOpen){
      this.closeProject(e);
    }
    var elmnt = document.getElementById("contact");
    elmnt.scrollIntoView();
  }
  render() {

    // MOVE THIS STUFF TO ITS OWN COMPONENT LATER ////////////////////

    

    // RENDER SERVICES SECTIONS //////////////////////////////////////
    /*<ProjectViewer
          currentPage = {this.state.currentPage}
          changePage={this.changePage.bind(this)}
          toggleProject={this.toggleProject.bind(this)}
           projectIsOpen={this.state.projectIsOpen}
           project_images={Project_Images}
           current_project={this.state.currentProject}
           project_data={Projects[this.state.currentProject]}
        />*/
    
        var about_portrait_code;
        var header_portrait_code;
        if(getWidth() >= 1000){
          about_portrait_code = portrait2_code;
        }else{
          header_portrait_code = portrait2_code;
        }
    
    return (
      <div id="App" className="App">
        <ProjectViewer
           closeProject={this.closeProject.bind(this)}
           projectIsOpen={this.state.projectIsOpen}
           current_project={this.state.currentProject}
           case_images = {Case_Images}
           project_is_opening = {this.state.project_is_opening}
           project_is_done_opening = {this.project_is_done_opening.bind(this)}
           project_data={this.state.projects[this.state.currentProject]}
           get_in_touch={this.get_in_touch.bind(this)}
        />
        <PrettyViewer
           closeProject={this.closeProject.bind(this)}
           prettyIsOpen={this.state.prettyIsOpen}
           currentProject={this.state.currentProject}
           pretty_images = {Pretty_Images}
           pretty_data = {pretty_data}
           project_data={this.state.projects[this.state.currentProject]}
        />
        <PageHeader
          currentPage = {this.state.currentPage}
          changePage={this.changePage.bind(this)}
          portrait_code={header_portrait_code}
        />
        <CaseStudies
          case_data = {case_data}
          case_images = {Case_Images}
          changePage={this.changePage.bind(this)}
          projectIsOpen = {this.state.projectIsOpen}
        />
        <PrettyThings
          pretty_data = {pretty_data}
          case_images = {Case_Images}
          pretty_images = {Pretty_Images}
          open_pretty = {this.open_pretty.bind(this)}
          changePage={this.changePage.bind(this)}
        />
        <About
          portrait_code={about_portrait_code}
        />
        <Contact/>

      </div>
    );
  }
}





export default App;



var main_pages = ["contact","about","pretty","case","home"];



///////////////////////////////////////////////////////
//////////////   BOOK NATION CASE STUDY   /////////////
///////////////////////////////////////////////////////

var BN_Case_Study = {
  sections:
  [
    {
      WorkType:"Narrative Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"half-width",
          title:"The Goal",
          text:"A cohesive, unified narrative that illustrates the problem of literacy in Savannah and what Book Nation is doing to try and address it. The deliverable (a slide deck) should allow the team to share their narrative with investors, volunteers, and clients."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/literacy_is_the_foundation.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Interviews",
          text:"Book Nation was started by Dreami Smith, but the team had grown to include several other passionate individuals. As I got to know the team, it became clear that each team member brought a unique perspective on the issue of literacy in Savannah. I conducted a series of interviews with each team member and helped unpack each of their visions for the organization."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_team.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/interview_transcript_flat.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Synthesis",
          text:"Following our interviews, I dug through the notes & transcripts to pull out key insights, themes, and big ideas. I aggregated the most important insights into a deck and reviewed it together with the team."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_synthesis1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_synthesis2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Prioritization & Narrative Development",
          text:"Working together with the team, we organized their various initiatives into primary and secondary focuses, and were able to paint a compelling picture of the issue of literacy that Book Nation was trying to bring awareness to."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/literacy_programs.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/barriers_to_literacy.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"The team walked away with a more unified perspective on the problem, as well as their approach. This early work with the team left us in a good place to be able to begin translating Book Nation’s vision into the new brand & website assets we would be developing."
        }
      ]
    },
    {
      WorkType:"Brand Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"The Book Nation team had been bootstrapping their initiatives as they got off the ground, but now they were ready to take things to the next level. In order to start raising some serious funding for their literacy programs, they needed a strong brand that people could trust & invest in."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["book_nation/bn_brand_kit_closeup.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Visual Inspiration",
          text:"As we narrowed in on their messaging, we started to explore some visual imagery as well. I spent time with the team reviewing the websites & branding of other similar organizations to get a sense of what resonated with Book Nation."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["book_nation/bn_inspiration_logos.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Metaphors",
          text:"I find metaphors are often a great place to start when developing logos – they’re specific enough to be able to provide some conceptual direction, but not so specific that the team gets too attached to a particular piece of imagery. I used a method inspired by the Cheatstorming ideation framework to first identify imagery, and secondly create metaphors to tie the imagery together."
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["book_nation/metaphor.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Logo Sketch Explorations",
          text:"I took our findings from those exploratory efforts and created a set of low-fi logos for the team to review."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["book_nation/bn_logo_sketches.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Refined Digital Logos",
          text:"The team gave feedback and from that set we chose three to develop further. "
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["book_nation/bn_logos_selection_flat.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Final Selection",
          text:"Finally, the team found themselves centering around one of the logos that really resonated with both the literacy focus of their work, and the feeling of growth, rebirth, and opportunity that they wanted their brand to emulate."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_final_logo.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_final_branding.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"At this point we had a logo, messaging, and some early direction on color. Some brand designers will use color scheme as a starting point to help give unity and direction to everything else. With Book Nation I took the approach of leaving color still fairly loose at this point, and giving ourselves the flexibility to pin down color as we got the chance to see the brand expressed within more tangible mediums like the website."
        }
      ]
    },
    {
      WorkType:"Web Development & Content",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"half-width",
          title:"The Goal",
          text:"A good looking website that communicates Book Nation’s vision and serves as a hub for promoting events, collecting donations, organizing volunteers, and gathering new literacy program participants."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:book_nation_header_img
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Collecting Assets",
          text:<span>Gathering & refining the content is always one of the big tasks when building a new website. Since the team was located on the other side of the country they would have to gather any photo assets themselves. I assigned team members tasks to begin gathering content. <br/><br/><b1>For BN's website we needed:</b1><ul><li>Headshots & bios of the team</li><li> Event photography of lending libraries & book drives</li><li> Origin story of the organization</li><li>Details of upcoming events</li></ul></span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["book_nation/site_files.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Choosing a CMS",
          text:"Since this website would mainly be information-oriented, Wix was an easy choice for this project as it provided the flexibility for content management as well as a powerful suite of web development tools. "
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/wix_comparison.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_wix_template.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Outlining the Website",
          text:"I find a good old Google Doc to be the best tool for laying out website content & getting collaborative input from the team. Together, we outlined the main pages of the website & developed the copy. "
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["book_nation/bn_website_copy.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Content Creation",
          text:"I put together a few rough sketches of the site to get a sense of the flow. Overall, the client wanted something straightforward and functional and so we opted not to spend a ton of time iterating. Instead we leveraged some pre-built components that Wix offered and worked to keep those as cohesive as possible with our branding. "
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_figma.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Putting It All Together",
          text:"From there, it was a fairly easy job of applying a color scheme, filling in the content, and double-checking the mobile & desktop views for cohesion. I’m glad we got started early on collecting content because some of the assets like headshots"
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_wix_dash.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["book_nation/bn_wix_editing.png"]
        },
        {
          type:"text",
          subType:"sub-text",
          format:"half-width",
          title:"Communications Strategy",
          text:<span><b2>Communications Strategy – </b2>A website is only as good as the people it helps you reach. I helped BN build a strategy around communications & outreach. Together we identified a member of their team that could lead outreach efforts and be accountable for keeping the website updated with new events.</span>
        },
        {
          type:"text",
          subType:"sub-text",
          format:"half-width",
          title:"Brand Strategy",
          text:<span><b2>Brand Strategy – </b2>Book Nation is still a young organization and when you’re in the early stages of development and moving fast, its hard to keep everything unified and cohesive. We kept that in mind while developing their brand application strategy and focused on a few simple versions of their branding that could be applied in the most common use cases. I’m sure that their branding system will need to continue to evolve as they learn more about what types of materials and formats they’re most often working with.</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"Overall we’re all pretty happy with how the website came out. Its a massive improvement from the site they were working with previously, and the team seems pretty excited about the branding & narrative work they walked away with as well."
        }
      ]
    }
  ]
};

///////////////////////////////////////////////////////
///////////   FRUIT BY THE BAY CASE STUDY   ///////////
///////////////////////////////////////////////////////

var FBTB_Case_Study = {
  sections:
  [
    {
      WorkType:"Market & UX Research",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:<span>In order to launch a residential delivery business, we needed to better understand people needs, behaviors, and budgets when it came to buying produce. To do that I consulted <a href="https://www.sfgate.com/local-donotuse/article/Fruit-Jesus-San-Francisco-delivery-FruitRollup-14435094.php">Fruit Jesus</a> himself, along with a survey & interviews with potential clients.</span>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/fruit_research.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"The Expert Consult",
          text:"My friend Konstantin was the inspiration to start Fruit By The Bay. When the pandemic shut down SF workplaces, Konstantin's business delivering fruit to tech offices was shut down as well. But together we brainstormed a way to bring fruit directly to people through a residential delivery service. In order to frame the challenge of building this new business, I worked with Konstantin to unpack his deep knowledge of fruit acquisition & delivery."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/konstantin_profile.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Delivery Optimization",
              text:"Produce is constantly going bad – the time from market pickup to delivery needs to be 1 day max."
            },
            {
              title:"Produce Preferences",
              text:"Many people have preferences when it comes to their produce. The service needs to handle customization."
            },
            {
              title:"Payment Management",
              text:"With Konstantin's clients he had to spend a lot of time following up with customer's to get payments."
            },
            {
              title:"Delivery Coordination",
              text:"Making sure someone can be available to accept the delivery is crucial and requires strong communication."
            },
            {
              title:"New Customers",
              text:"Handling intake for new customers requires someone to be on-call all the time to give them info about the service & figure out what they want."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Market Survey",
          text:"Konstantin and I leveraged our local networks and some of his former office clients to get input on a market survey. Our goal here was to learn what people's produce budgets looked like and get a general idea of what was important to them in considering a produce delivery service. Here's what we learned:"
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/survey_probe.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Household Size Informs Budget",
              text:"We found that produce budgets vary greatly based on the size of the household. The people who were willing to spend more, were generally feeding more people."
            },
            {
              title:"Quality Is Key",
              text:"The people who were willing to pay more, were happy to do so as long as they were getting the *best of the best* fruit."
            },
            {
              title:"Spontaneity",
              text:"A few respondants cared a lot about veggie preferences, wanting to be able to get specific things to match the meals they had plannned. Others liked the spontaneity of getting something different each week."
            },
            {
              title:"People Like Subscriptions",
              text:"Almost all of the respondants were interested in paying through a digital subscription."
            },
            {
              title:"Trying New Things",
              text:"Most people in our survey were excited about the opportunity to try new fruits or vegetables, but also wanted to have a balance of familiar favorites."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Competitive Interviews & Analysis",
          text:"Often one of the best ways to forecast potential UX challenges with a new service is to interview clients of a competing service about their experiences. In order to develop a well-informed competitive analysis, I interviewed customers of Farm-Fresh-To-You, Imperfect Produce, and a few other produce delivery services."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/user_interviews.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Paradox of Choice",
              text:"Farm-Fresh-To-You's service was one of the better interfaces among the options available at the time. However, one family we interviewed felt that the service required regular customization management, when really they just wanted to \"set it and forget it.\""
            },
            {
              title:"More of My Favorites",
              text:"A customer of another local service told us that if they could change one thing about the service, it would be to get more of their favorite produce. The service didn't have a way for them to express which fruits they loved and get extras when they were in season, like they used to do at the farmer's market."
            },
            {
              title:"Hungry To Learn",
              text:"A customer of Greenhearts Family Farm CSA told us that a big motivator to use that service was the information they provided about what was in season, and other informational tid-bits that made them feel more connected to the food."
            },
            {
              title:"Skipping Deliveries",
              text:"A person using Imperfect Produce's service told us that the only time they logged into the website was to pause or restart their servive whenever they went out of town – this was a key functionality post-order."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"We got a TON of great insights out of this research and I was even able to conduct it all remotely (since at the time I was holed-up with my family on the East Coast during the early pandemic.) We came away with a much better idea of what the service should look like and who the people are who wanted to sign up."
        }
      ]
    },
    {
      WorkType:"UI Design: Web & Ordering",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"A big piece of the produce delivery business involves onboarding new clients. Our research taught us that there are a lot of considerations that people have in choosing where they get their produce – we needed to make sure that our client intake portal could handle the right information & inputs for our target audience. To do this, I built a website and new order form."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/new_order_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Mapping the Flow",
          text:"I had a few peices of the puzzle from our previous survey & interviews – now it was time to start putting it together into a cohesive end-to-end flow. I created a low-fi map of the stages of the decision-making process as I currently understood them."
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["fbtb/new_client_flow_sketch.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Outline",
          text:"Because I wanted a high level of control over the website's order form, it made sense to do a custom build. Thus, we need two different outlines: one to break down the technical components of the website ordering system as well as one for laying out the website content."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/technical_outline.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/content_outline.png"]
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>A Technical Outline</b2> defines out how we'll hook together the different systems we're utilizing to process orders and perform follow-up actions such as confirmation emails & adding new rows into our order management spreadsheet.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>A Content Outline </b2>begins with a rough site map for the website that gives us a framework to start developing the content. A google doc provides a space to lay out the copy & imagery.</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Design Specs",
          text:"Now that we had the website outlined, I channeled this information into a set of website design specs in Figma. Most of the website was informational so it was pretty straightforward to design the web & mobile versions."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_figma.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Development",
          text:"React.js is one of the quickest frameworks for front-end development and a great tool for custom form-building. Google's Firebase is a lightweight website hosting & database system that enabled us to store & process orders and cue follow-up events like emails & spreadsheet submissions."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_react.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"This website was a fun development challenge to build some of the more dynamic components like the seasonal produce chart & the ordering form. As I was designing the new client journey, I was simultaneously developing an aesthetic direction for the branding & imagery. I'll expand on that process in the next section."
        }
      ]
    },
    {
      WorkType:"Brand Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"The branding for FBTB was important – as a new service asking people to sign up for weekly payments we needed to project a trustworthy face to our potential clients as well as reflecting our community & sustainability-oriented values."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/branding_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Competitor Brand Analysis",
          text:"I performed a brand analysis of some of the competing services to get an idea of how others were approaching their branding, messaging, & imagery. Below are some of my takeaways:"
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/competitor_brand_analysis.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Vibe: Bauhaus vs. Barnhouse",
              text:<span>In terms of overall aesthetic, most of the services fell on a spectrum: on one end are brands like Imperfect Produce with the classic clean & white with bright colors & product cutouts. On the other end of the spectrum is the earthy, textured, back-to-the-land-ey vibes of Farm-Fresh-To-You. To me, the FFTY textured aesthetic just felt a little outdated and I didn't want our brand to feel like just another small-time CSA.</span>
            },
            {
              title:"Photos: Instagram vs Reality",
              text:"In particular, I noticed Imperfect Produce's instagram-ification approach to photography felt very disconnected from the produce itself. Sure, the produce should look clean & delicious, but it was important to make sure the photos felt *real*."
            },
            {
              title:"Imagery & Iconography",
              text:"Some brands like Good Eggs completely avoided any graphic imagery and let their product photos do the talking. While I thought this worked well for them as more of a full-service grocery, our service was all about giving up that control over your produce choices and instead celebrating the art of hand-picking the best, ripe, seasonal produce available locally. I wanted to find imagery that brought that feeling to life."
            },
            {
              title:"Typography",
              text:"Again, here there was largely a spectrum from clean, sans-serif vibes over to more unique, hand-written typefaces. It was a tough choice, because I think we wanted the flexibility to step into each of those aesthetic spaces."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Aesthetic Direction",
          text:<span>After some visual experimentation & time spent perusing pinterest, I landed on a visual direction that felt like the right fit.<br/><br/>The overall vibe is bright & fresh. I brought in well-lit produce photography alongside some beautiful watercolor textures & imagery that I had come across. In terms of type, I explored a mix of bold sans-serif along with some hand-drawn fonts mixed in for callouts.</span>
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["fbtb/aesthetic_inspo.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Logo Sketch Explorations",
          text:"I spent some time sketching logos to arrive at a direction I felt happy with. Round fruit like apples, peaches or pears are easily recognizable and evocative of our core offering – fruit. Combining that with the wave illustration brought in the other half of our name, Fruit By The Bay. I wanted the name & logo to speak to the Bay Area as a whole without having to rely on iconic imagery like the GG bridge or other clichés."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_sketches.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Logo Refinement",
          text:"The final logo brought together a few of the aesthetic elements I was leaning into – the hand-drawn type, and the watercolor underlays. Importantly, it paired well with both bold sans-serif type and the hand-drawn logo font."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_card_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_card_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Photography & Graphics",
          text:"In addition to the logo, it was important to spend time getting the photo & graphic imagery right since this content would be used throughout our website & marketing materials. I conducted photoshoots and spent time developing a set of graphics that could be used interchangably when developing new content."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_homepage.png"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_photo_card.jpeg"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_bg_photo.png"]
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_how_it_works.png"]
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"When we started our advertising & promotion work, we got a lot of appreciation from customers around our website & branding. The I found we were able to leverage the branding content I had developed across both our website & flyers without it feeling forced. And importantly, people understood what our company was about when they saw it."
        }
      ]
    },
    {
      WorkType:"Marketing & Ads",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"To launch the delivery service I needed to build a solid client acquisition funnel – one that would allow us to grow our customer base and continue to bring in enough new clients to make up for any turnover."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/marketing_header.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Marketing Toolkit",
          text:<span>There are two key activities when developing a marketing toolkit for a new service like ours – experimentation and the numbers game.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"pre-text",
          text:<span><b2>Experimenting</b2> is the challenging but fun part of marketing. Experimentation can range from developing new ad creative all the way to new mediums or channels for your outreach, but the goal is the same. You make informed guesses at what might work, test it, review the results, and iterate.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"pre-text",
          text:<span><b2>The numbers game</b2> on the other hand is all about applying & evolving tested methods to bring in new customers. In this case, you probably know what the ROI is gonna look like (ex: 1 customer per 200 flyers). But is there a more efficient way to distribute those flyers? It can often be boiled down to a formula with a clear input and output.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/competitor_brand_analysis.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Word of Mouth / Referrals",
              text:<span>Making some noise among our friends and existing network helped us get an initial boost of clients. Referrals from existing customers also provided a steady stream of new clients. We made sure to provide coupon codes for existing customers to share.</span>
            },
            {
              title:"Flyers & Posters",
              text:"Another easy strategy for us was flyer distribution – as we made our delivery routes we would drop off flyers at the nearby houses – this strategy was great because getting clients who are close together makes for efficient deliveries."
            },
            {
              title:"Local News",
              text:<span>After helping Konstantin revamp his business, I encouraged him to reach out to his network to see if he could get an article written about it. Luckily, he was able to get a new SF Gate article – that brought a huge boost of new clients for him and brought some East Bay clients to Fruit By The Bay as well.</span>
            },
            {
              title:"Social Media (organic)",
              text:"We encouraged our existing clients to share our service on social media and we spent some time sharing some of our own content as well. We did get some client throughput this way, but this didn't turn out to be a hugely successful driver of new clients for us."
            },
            {
              title:"Social Media (paid)",
              text:"Paid social media is something we tested out a little bit, but overall we found it found to be cost-prohibitive as we were getting off the ground."
            },
            {
              title:"Google Ads",
              text:"Google ads turned out to be a tough space as well – the other bigger businesses have capitalized on this approach so the CPC is driven up fairly high.."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"What Worked",
          text:<span>After putting time into a number of different approaches, flyer distribution turned out to be our most successful acquisition tool, second only to the initial big wave of clients we got from the SF Gate article. Our 4x6 flyers served as a versitile marketing asset that could be distributed to mailboxes, left in a stack for pickup, or included in client's produce boxes to be given out to friends & family.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/flyer_side_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/flyer_side_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Flyer Optimization",
          text:<span>After distributing several batches of flyers, our success rate was roughly 1 new customer per 200 flyers delivered which all-things considered was a good start, but I knew we could do better. The obvious next iteration was to test out <b1>Coupon Codes.</b1> I built a coupon code module into our website's order system so customers could input their code, and then I developed a set of 2 coupon codes to compare: $10 off the first order, vs 50% off the first order.<br/><br/>I printed & distributed an equal number of each type of flyer and found that the 50% off codes performed at 1 acquisition per 100, while the $10 off codes performed at 1 acquisition per 160. Even factoring in the bigger discount we were giving people, the 50% off code was the clear winner and we continued to distribute these flyers along with our deliveries.</span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/website_coupon_code.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"CPA, Retention, & LTV",
          text:<span>Each flyer cost about 40¢ to print, so at 100 flyers per acquisition our CPA stood at about $40 – was it worth it? Well that all depends on the LTV.<br/><br/>After 1 year of operation our averaged client retention rate was staying consistently at around 4 months which was pretty solid! We had a fair number of people who would try the service for a few weeks and decide its not for them, and then many others who had been with us since the beginning. Averaging the range of different price-points people were paying and then subtracting the cost of the produce & delivery, our LTV was around $240/client, high enough to justify our go-to marketing strategy with the flyers.</span>
        },
        /*{
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/blank_case_img.png"]
        },*/
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Further Iteration",
          text:"If I were to keep going with pushing this marketing approach I would have tried out exploding coupon codes (\"offer only valid until...\"). I also think now that we had refined our messaging & motivators we could try to incorporate those factors into a digital approach through content marketing or ads. Furthermore, the website could continue to be optimized by offering coupon codes in exchange for email sign-ups, etc."
        }
      ]
    },
    {
      WorkType:"Operations Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:<div>To build an effecient & viable delivery service, we needed a smooth operations process that allowed us to:<ul><li>Build a strong delivery team</li><li>Acquire the best produce each week</li><li>Sort the produce</li><li>Plan delivery routes</li><li>Maintain consistent communications</li><li>Reduce waste</li></ul></div>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/operations_header.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Building A Delivery Team",
          text:<span>Large-scale produce delivery requires a team of people who are in tight communication, familiar with the produce, and knowledgable about their delivery area. Luckily I was able to find a team of delivery partners who brought together the right skills and knowledge to make our operation a success.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/shen_headshot.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/edward_headshot.jpeg"]
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>Shenandoah</b2> is a Berkeley student & barista. Her experience managing coffee shops meant that she had a nack for managing an operation across multiple dimensions. Shenandoah headed our Berkeley delivery operation and oversaw the delivery route planning & communications.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>Edward</b2> is a long-time Alameda resident. His deep familiarity with the area turned out to be a huge asset for the team, and he headed our Alameda delivery operations. Edward also used a custom electric delivery vehicle to make his deliveries which we loved!</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Produce Acquisition",
          text:"The produce selection at the markets constantly changes with each new season. Different markets have a different set of farmers and their produce quality & prices fluctuate too. To handle produce acquisition under such variable conditions, I developed a spreadsheet system to track produce availability & quality, and to make a catalog of availability at each of the markets."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/farmers_list_blur2.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/farmers_market_stand_2.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Fruit Sorting",
          text:"Once we had the bulk fruit, now it needed to get sorted into each client's box depending on what they had ordered. We developed a system of different boxes that corresponded to each price point and delivery type (just fruit vs. fruit + veggies). I rented a warehouse & commercial refrigerator space that we used to run our sorting process and keep the produce fresh the whole time. We timed our delivery windows with the markets in order to be able to get produce from the market to client's doorstep by the very next day."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fruit_kitchen.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fruit_truck.jpeg"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fruit_sorting.jpeg"]
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fruit_boxes.jpeg"]
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Route Planning",
          text:<div>In the delivery service, efficiency is key. To make the numbers work, you need to be able to make a certain numher of deliveries per hour. I developed a route planning & mapping system that my delivery drivers could use to manage their deliveries. I developed a <b2>Google Spreadsheet</b2> that we used to track the deliveries and then channeled those into <b2>My Maps,</b2> a Google application that allowed you to map a large series of locations, and connect each one to the key information for that delivery such as what should be in the box, or the client's special delivery instructions.</div>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/delivery_spreadsheet_blur.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/delivery_routes.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Delivery Communications",
          text:<span>To make our deliveries efficiently, we needed to be able to project an accurate delivery time window for each of our customers. Using My Maps & our delivery spreadsheet we broke down the set of deliveries into routes. After several iterations on route sizes we found that 1 hour delivery windows gave the right amount of flexibility & efficiency. Using this system we were able to make the deliveries efficiently, but also keep enough flexibility for drivers to not get thrown off-schedule when there was an unexpected delivery hiccup. <br/><br/>I used a tool called Text Magic to set up an automated messaging system to send a text each morning before deliveries with their estimated delivery time window. After a few weeks of working out the kinks we were able to achieve a 90% success rate of making deliveries within the estimated time window.</span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/delivery_comms.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Reducing Waste",
          text:<div>An important part of our service was focused on waste reduction. In order to keep our waste as low as possible we:<ul><li>Worked only with California farmers to avoid long-distance shipping of produce.</li><li>Utilized electric delivery vehicles whenever possible</li><li>Tracked our left-over produce to keep our purchase process as efficient as possible.</li><li>Collected & re-used delivery and berry-baskets to eliminate almost all non-compostable waste from our service.</li><li>Donated excess produce to community food centers.</li></ul></div>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/town_fridge.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/electric_car.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:<div>I was surprised at how well we were able to accomplish our operational goals with running our service. Our deliveries were largely consistent & timely, and we were able to reduce the amount of time spent by a factor of three from when we first started. One area I would have been interested to push even further is in the waste reduction – a lot goes in to achieving a truly "zero-waste" service. While we were very close, there was still the gas used to drive the delivery vehicles, and plastic dairy bottles that could only be recylced but not re-used. If we kept going with our service, I would have liked to partner with a company like Straus Creamery which uses glass bottles that they recollect & re-use.</div>
        }
      ]
    }
  ]
};



///////////////////////////////////////////////////////
////////////   AUTODESK ATLAS CASE STUDY   ////////////
///////////////////////////////////////////////////////

var Atlas_Case_Study = {
  sections:
  [
    {
      WorkType:"Research",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Challenge",
          text:<span>In order to launch a residential delivery business, we needed to better understand people needs, behaviors, and budgets when it came to buying produce. To do that I consulted <a href="https://www.sfgate.com/local-donotuse/article/Fruit-Jesus-San-Francisco-delivery-FruitRollup-14435094.php">Fruit Jesus</a> himself, along with a survey & interviews with potential clients.</span>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/fruit_research.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"The Expert Consult",
          text:"My friend Konstantin was the inspiration to start Fruit By The Bay. When the pandemic shut down SF workplaces, Konstantin's business delivering fruit to tech offices was shut down as well. But together we brainstormed a way to bring fruit directly to people through a residential delivery service. In order to frame the challenge of building this new business, I worked with Konstantin to unpack his deep knowledge of fruit acquisition & delivery."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/konstantin_profile.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Delivery Optimization",
              text:"Produce is constantly going bad – the time from market pickup to delivery needs to be 1 day max."
            },
            {
              title:"Produce Preferences",
              text:"Many people have preferences when it comes to their produce. The service needs to handle customization."
            },
            {
              title:"Payment Management",
              text:"With Konstantin's clients he had to spend a lot of time following up with customer's to get payments."
            },
            {
              title:"Delivery Coordination",
              text:"Making sure someone can be available to accept the delivery is crucial and requires strong communication."
            },
            {
              title:"New Customers",
              text:"Handling intake for new customers requires someone to be on-call all the time to give them info about the service & figure out what they want."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Market Survey",
          text:"Konstantin and I leveraged our local networks and some of his former office clients to get input on a market survey. Our goal here was to learn what people's produce budgets looked like and get a general idea of what was important to them in considering a produce delivery service. Here's what we learned:"
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/survey_probe.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Household Size Informs Budget",
              text:"We found that produce budgets vary greatly based on the size of the household. The people who were willing to spend more, were generally feeding more people."
            },
            {
              title:"Quality Is Key",
              text:"The people who were willing to pay more, were happy to do so as long as they were getting the *best of the best* fruit."
            },
            {
              title:"Spontaneity",
              text:"A few respondants cared a lot about veggie preferences, wanting to be able to get specific things to match the meals they had plannned. Others liked the spontaneity of getting something different each week."
            },
            {
              title:"People Like Subscriptions",
              text:"Almost all of the respondants were interested in paying through a digital subscription."
            },
            {
              title:"Trying New Things",
              text:"Most people in our survey were excited about the opportunity to try new fruits or vegetables, but also wanted to have a balance of familiar favorites."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Competitive Interviews & Analysis",
          text:"Often one of the best ways to forecast potential UX challenges with a new service is to interview clients of a competing service about their experiences. In order to develop a well-informed competitive analysis, I interviewed customers of Farm-Fresh-To-You, Imperfect Produce, and a few other produce delivery services."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/user_interviews.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Paradox of Choice",
              text:"Farm-Fresh-To-You's service was one of the better interfaces among the options available at the time. However, one family we interviewed felt that the service required regular customization management, when really they just wanted to \"set it and forget it.\""
            },
            {
              title:"More of My Favorites",
              text:"A customer of another local service told us that if they could change one thing about the service, it would be to get more of their favorite produce. The service didn't have a way for them to express which fruits they loved and get extras when they were in season, like they used to do at the farmer's market."
            },
            {
              title:"Hungry To Learn",
              text:"A customer of Greenhearts Family Farm CSA told us that a big motivator to use that service was the information they provided about what was in season, and other informational tid-bits that made them feel more connected to the food."
            },
            {
              title:"Skipping Deliveries",
              text:"A person using Imperfect Produce's service told us that the only time they logged into the website was to pause or restart their servive whenever they went out of town – this was a key functionality post-order."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"We got a TON of great insights out of this research and I was even able to conduct it all remotely (since at the time I was holed-up with my family on the East Coast during the early pandemic.) We came away with a much better idea of what the service should look like and who the people are who wanted to sign up."
        }
      ]
    },
    {
      WorkType:"UI Design: Web & Ordering",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"A big piece of the produce delivery business involves onboarding new clients. Our research taught us that there are a lot of considerations that people have in choosing where they get their produce – we needed to make sure that our client intake portal could handle the right information & inputs for our target audience. To do this, I built a website and new order form."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/new_order_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Mapping the Flow",
          text:"I had a few peices of the puzzle from our previous survey & interviews – now it was time to start putting it together into a cohesive end-to-end flow. I created a low-fi map of the stages of the decision-making process as I currently understood them."
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["fbtb/new_client_flow_sketch.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Outline",
          text:"Because I wanted a high level of control over the website's order form, it made sense to do a custom build. Thus, we need two different outlines: one to break down the technical components of the website ordering system as well as one for laying out the website content."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/technical_outline.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/content_outline.png"]
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>A Technical Outline</b2> defines out how we'll hook together the different systems we're utilizing to process orders and perform follow-up actions such as confirmation emails & adding new rows into our order management spreadsheet.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>A Content Outline </b2>begins with a rough site map for the website that gives us a framework to start developing the content. A google doc provides a space to lay out the copy & imagery.</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Design Specs",
          text:"Now that we had the website outlined, I channeled this information into a set of website design specs in Figma. Most of the website was informational so it was pretty straightforward to design the web & mobile versions."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_figma.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Website Development",
          text:"React.js is one of the quickest frameworks for front-end development and a great tool for custom form-building. Google's Firebase is a lightweight website hosting & database system that enabled us to store & process orders and cue follow-up events like emails & spreadsheet submissions."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_react.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"This website was a fun development challenge to build some of the more dynamic components like the seasonal produce chart & the ordering form. As I was designing the new client journey, I was simultaneously developing an aesthetic direction for the branding & imagery. I'll expand on that process in the next section."
        }
      ]
    },
    {
      WorkType:"Brand Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"The branding for FBTB was important – as a new service asking people to sign up for weekly payments we needed to project a trustworthy face to our potential clients as well as reflecting our community & sustainability-oriented values."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/branding_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Competitor Brand Analysis",
          text:"I performed a brand analysis of some of the competing services to get an idea of how others were approaching their branding, messaging, & imagery. Below are some of my takeaways:"
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/competitor_brand_analysis.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Vibe: Bauhaus vs. Barnhouse",
              text:<span>In terms of overall aesthetic, most of the services fell on a spectrum: on one end are brands like Imperfect Produce with the classic clean & white with bright colors & product cutouts. On the other end of the spectrum is the earthy, textured, back-to-the-land-ey vibes of Farm-Fresh-To-You. To me, the FFTY textured aesthetic just felt a little outdated and I didn't want our brand to feel like just another small-time CSA.</span>
            },
            {
              title:"Photos: Instagram vs Reality",
              text:"In particular, I noticed Imperfect Produce's instagram-ification approach to photography felt very disconnected from the produce itself. Sure, the produce should look clean & delicious, but it was important to make sure the photos felt *real*."
            },
            {
              title:"Imagery & Iconography",
              text:"Some brands like Good Eggs completely avoided any graphic imagery and let their product photos do the talking. While I thought this worked well for them as more of a full-service grocery, our service was all about giving up that control over your produce choices and instead celebrating the art of hand-picking the best, ripe, seasonal produce available locally. I wanted to find imagery that brought that feeling to life."
            },
            {
              title:"Typography",
              text:"Again, here there was largely a spectrum from clean, sans-serif vibes over to more unique, hand-written typefaces. It was a tough choice, because I think we wanted the flexibility to step into each of those aesthetic spaces."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Aesthetic Direction",
          text:<span>After some visual experimentation & time spent perusing pinterest, I landed on a visual direction that felt like the right fit.<br/><br/>The overall vibe is bright & fresh. I brought in well-lit produce photography alongside some beautiful watercolor textures & imagery that I had come across. In terms of type, I explored a mix of bold sans-serif along with some hand-drawn fonts mixed in for callouts.</span>
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["fbtb/aesthetic_inspo.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Logo Sketch Explorations",
          text:"I spent some time sketching logos to arrive at a direction I felt happy with. Round fruit like apples, peaches or pears are easily recognizable and evocative of our core offering – fruit. Combining that with the wave illustration brought in the other half of our name, Fruit By The Bay. I wanted the name & logo to speak to the Bay Area as a whole without having to rely on iconic imagery like the GG bridge or other clichés."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_sketches.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Logo Refinement",
          text:"The final logo brought together a few of the aesthetic elements I was leaning into – the hand-drawn type, and the watercolor underlays. Importantly, it paired well with both bold sans-serif type and the hand-drawn logo font."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_card_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_logo_card_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Photography & Graphics",
          text:"In addition to the logo, it was important to spend time getting the photo & graphic imagery right since this content would be used throughout our website & marketing materials. I conducted photoshoots and spent time developing a set of graphics that could be used interchangably when developing new content."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_homepage.png"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_photo_card.jpeg"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_bg_photo.png"]
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fbtb_how_it_works.png"]
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"When we started our advertising & promotion work, we got a lot of appreciation from customers around our website & branding. The I found we were able to leverage the branding content I had developed across both our website & flyers without it feeling forced. And importantly, people understood what our company was about when they saw it."
        }
      ]
    },
    {
      WorkType:"Marketing & Ads",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"To launch the delivery service I needed to build a solid client acquisition funnel – one that would allow us to grow our customer base and continue to bring in enough new clients to make up for any turnover."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/marketing_header.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Marketing Toolkit",
          text:<span>There are two key activities when developing a marketing toolkit for a new service like ours – experimentation and the numbers game.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"pre-text",
          text:<span><b2>Experimenting</b2> is the challenging but fun part of marketing. Experimentation can range from developing new ad creative all the way to new mediums or channels for your outreach, but the goal is the same. You make informed guesses at what might work, test it, review the results, and iterate.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"pre-text",
          text:<span><b2>The numbers game</b2> on the other hand is all about applying & evolving tested methods to bring in new customers. In this case, you probably know what the ROI is gonna look like (ex: 1 customer per 200 flyers). But is there a more efficient way to distribute those flyers? It can often be boiled down to a formula with a clear input and output.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/competitor_brand_analysis.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"Word of Mouth / Referrals",
              text:<span>Making some noise among our friends and existing network helped us get an initial boost of clients. Referrals from existing customers also provided a steady stream of new clients. We made sure to provide coupon codes for existing customers to share.</span>
            },
            {
              title:"Flyers & Posters",
              text:"Another easy strategy for us was flyer distribution – as we made our delivery routes we would drop off flyers at the nearby houses – this strategy was great because getting clients who are close together makes for efficient deliveries."
            },
            {
              title:"Local News",
              text:<span>After helping Konstantin revamp his business, I encouraged him to reach out to his network to see if he could get an article written about it. Luckily, he was able to get a new SF Gate article – that brought a huge boost of new clients for him and brought some East Bay clients to Fruit By The Bay as well.</span>
            },
            {
              title:"Social Media (organic)",
              text:"We encouraged our existing clients to share our service on social media and we spent some time sharing some of our own content as well. We did get some client throughput this way, but this didn't turn out to be a hugely successful driver of new clients for us."
            },
            {
              title:"Social Media (paid)",
              text:"Paid social media is something we tested out a little bit, but overall we found it found to be cost-prohibitive as we were getting off the ground."
            },
            {
              title:"Google Ads",
              text:"Google ads turned out to be a tough space as well – the other bigger businesses have capitalized on this approach so the CPC is driven up fairly high.."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"What Worked",
          text:<span>After putting time into a number of different approaches, flyer distribution turned out to be our most successful acquisition tool, second only to the initial big wave of clients we got from the SF Gate article. Our 4x6 flyers served as a versitile marketing asset that could be distributed to mailboxes, left in a stack for pickup, or included in client's produce boxes to be given out to friends & family.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/flyer_side_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/flyer_side_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Flyer Optimization",
          text:<span>After distributing several batches of flyers, our success rate was roughly 1 new customer per 200 flyers delivered which all-things considered was a good start, but I knew we could do better. The obvious next iteration was to test out <b1>Coupon Codes.</b1> I built a coupon code module into our website's order system so customers could input their code, and then I developed a set of 2 coupon codes to compare: $10 off the first order, vs 50% off the first order.<br/><br/>I printed & distributed an equal number of each type of flyer and found that the 50% off codes performed at 1 acquisition per 100, while the $10 off codes performed at 1 acquisition per 160. Even factoring in the bigger discount we were giving people, the 50% off code was the clear winner and we continued to distribute these flyers along with our deliveries.</span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/website_coupon_code.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"CPA, Retention, & LTV",
          text:<span>Each flyer cost about 40¢ to print, so at 100 flyers per acquisition our CPA stood at about $40 – was it worth it? Well that all depends on the LTV.<br/><br/>After 1 year of operation our averaged client retention rate was staying consistently at around 4 months which was pretty solid! We had a fair number of people who would try the service for a few weeks and decide its not for them, and then many others who had been with us since the beginning. Averaging the range of different price-points people were paying and then subtracting the cost of the produce & delivery, our LTV was around $240/client, high enough to justify our go-to marketing strategy with the flyers.</span>
        },
        /*{
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/blank_case_img.png"]
        },*/
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Further Iteration",
          text:"If I were to keep going with pushing this marketing approach I would have tried out exploding coupon codes (\"offer only valid until...\"). I also think now that we had refined our messaging & motivators we could try to incorporate those factors into a digital approach through content marketing or ads. Furthermore, the website could continue to be optimized by offering coupon codes in exchange for email sign-ups, etc."
        }
      ]
    },
    {
      WorkType:"Operations Development",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:<div>To build an effecient & viable delivery service, we needed a smooth operations process that allowed us to:<ul><li>Build a strong delivery team</li><li>Acquire the best produce each week</li><li>Sort the produce</li><li>Plan delivery routes</li><li>Maintain consistent communications</li><li>Reduce waste</li></ul></div>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["fbtb/operations_header.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Building A Delivery Team",
          text:<span>Large-scale produce delivery requires a team of people who are in tight communication, familiar with the produce, and knowledgable about their delivery area. Luckily I was able to find a team of delivery partners who brought together the right skills and knowledge to make our operation a success.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/shen_headshot.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/edward_headshot.jpeg"]
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>Shenandoah</b2> is a Berkeley student & barista. Her experience managing coffee shops meant that she had a nack for managing an operation across multiple dimensions. Shenandoah headed our Berkeley delivery operation and oversaw the delivery route planning & communications.</span>
        },
        {
          type:"text",
          format:"half-width",
          subType:"sub-text",
          text:<span><b2>Edward</b2> is a long-time Alameda resident. His deep familiarity with the area turned out to be a huge asset for the team, and he headed our Alameda delivery operations. Edward also used a custom electric delivery vehicle to make his deliveries which we loved!</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Produce Acquisition",
          text:"The produce selection at the markets constantly changes with each new season. Different markets have a different set of farmers and their produce quality & prices fluctuate too. To handle produce acquisition under such variable conditions, I developed a spreadsheet system to track produce availability & quality, and to make a catalog of availability at each of the markets."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/farmers_list_blur2.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/farmers_market_stand_2.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Fruit Sorting",
          text:"Once we had the bulk fruit, now it needed to get sorted into each client's box depending on what they had ordered. We developed a system of different boxes that corresponded to each price point and delivery type (just fruit vs. fruit + veggies). I rented a warehouse & commercial refrigerator space that we used to run our sorting process and keep the produce fresh the whole time. We timed our delivery windows with the markets in order to be able to get produce from the market to client's doorstep by the very next day."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fruit_kitchen.jpeg"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/fruit_truck.jpeg"]
        },
        {
          type:"image",
          format:"one-third",
          subType:"plain",
          img:Case_Images["fbtb/fruit_sorting.jpeg"]
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["fbtb/fruit_boxes.jpeg"]
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Route Planning",
          text:<div>In the delivery service, efficiency is key. To make the numbers work, you need to be able to make a certain numher of deliveries per hour. I developed a route planning & mapping system that my delivery drivers could use to manage their deliveries. I developed a <b2>Google Spreadsheet</b2> that we used to track the deliveries and then channeled those into <b2>My Maps,</b2> a Google application that allowed you to map a large series of locations, and connect each one to the key information for that delivery such as what should be in the box, or the client's special delivery instructions.</div>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/delivery_spreadsheet_blur.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/delivery_routes.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Delivery Communications",
          text:<span>To make our deliveries efficiently, we needed to be able to project an accurate delivery time window for each of our customers. Using My Maps & our delivery spreadsheet we broke down the set of deliveries into routes. After several iterations on route sizes we found that 1 hour delivery windows gave the right amount of flexibility & efficiency. Using this system we were able to make the deliveries efficiently, but also keep enough flexibility for drivers to not get thrown off-schedule when there was an unexpected delivery hiccup. <br/><br/>I used a tool called Text Magic to set up an automated messaging system to send a text each morning before deliveries with their estimated delivery time window. After a few weeks of working out the kinks we were able to achieve a 90% success rate of making deliveries within the estimated time window.</span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["fbtb/delivery_comms.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Reducing Waste",
          text:<div>An important part of our service was focused on waste reduction. In order to keep our waste as low as possible we:<ul><li>Worked only with California farmers to avoid long-distance shipping of produce.</li><li>Utilized electric delivery vehicles whenever possible</li><li>Tracked our left-over produce to keep our purchase process as efficient as possible.</li><li>Collected & re-used delivery and berry-baskets to eliminate almost all non-compostable waste from our service.</li><li>Donated excess produce to community food centers.</li></ul></div>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/town_fridge.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["fbtb/electric_car.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:<div>I was surprised at how well we were able to accomplish our operational goals with running our service. Our deliveries were largely consistent & timely, and we were able to reduce the amount of time spent by a factor of three from when we first started. One area I would have been interested to push even further is in the waste reduction – a lot goes in to achieving a truly "zero-waste" service. While we were very close, there was still the gas used to drive the delivery vehicles, and plastic dairy bottles that could only be recylced but not re-used. If we kept going with our service, I would have liked to partner with a company like Straus Creamery which uses glass bottles that they recollect & re-use.</div>
        }
      ]
    }
  ]
};



///////////////////////////////////////////////////////
//////////////////   MIRA – SEARCH   //////////////////
///////////////////////////////////////////////////////

var Mira_Search_Case_Study = {
  sections:
  [
    {
      WorkType:"User Journey Research",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:<span>In order to design a search experience that could handle both high-intent quieries and low-intent exploration, we would need to fundamentally rethink our UI and the way in which we enabled users to navigate the universe of content that we had aggregated for them. <b2>Our research goal was to develop an understanding of how search fits in to the greater purchase decision-making journey for our users.</b2></span>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["mira_search/decision_making_1_closeup.png"]
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Why Universal Search",
          text:<span>After launching our Beta version of our app, we spent some time talking to users and analyzing their behavior. It was clear that while users were enthusiastic about some parts of the app, the full fluid experience from product need to product decision was not there.<br/><br/>For the sake of launching an MVP we had previously broken down our core functionality into two different tabs – one for high-intent search, and another tab for exploration. While we had gotten good user engagement & feedback, people were getting confused as to which tab they should use. It turns out that throughout a session users tended to move between states of high & lower intent.<br/><br/><b2>The Old UI:</b2></span>
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["mira_search/mira_old_UI_transparent.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Phases of a Purchase Decision",
          text:<span>We wanted to begin with a clear picture of how search fits in to the greater product purchase decision-making journey for beauty enthusaists. In order to understand this process we conducted two rounds of research.<br/><br/><b2>Round 1: Discovery - </b2>In our first round of research, we used several research activities to gather a data from several points of view on a user's purchase journey. </span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/user_interview_small.png"]
        },
        {
          type:"list",
          subType:"numbered",
          format:"half-width",
          title:"Insights",
          list:[
            {
              title:"User Journaling",
              text:"We asked members of our target audience to log each of their makeup purchases in a journal. Participants were asked to catalog all the way from their first product interest through purchase."
            },
            {
              title:"In-app Observation",
              text:"Using FullStory, we were able to review the user sessions of our research participants in the app. This was useful, because often users may think they're just browsing when really its clear in hindsight they're looking for a particular product."
            },
            {
              title:"Survey",
              text:"We put out a typeform survey asking users about where they bought their makeup vs. where they 'discovered' their makeup vs. where they did their research. It turns out there's a wide variety of *inciting incidents* that nudge a user towards a product need."
            },
            {
              title:"User Interviews",
              text:"Finally, we rounded this research out with a series of in-depth user interviews where we got to hear first-hand how users were doing their product research."
            }
          ]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"half-width",
          title:"Round 2: Journey Mapping",
          text:<span>Using what we had gathered, we laid out common inciting events on a series of cards. Part 1 of the activity had users sorting the cards to identify which events most commonly kicked off a product search for them.<br/><br/>In part two of the activity our participants walked us through their search process going from each of their most common inciting events all the way through purchase. Along the way we cataloged which platforms they were using for each phase of their decision-making.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/card_sort_smaller.gif"]
        },
        {
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Results",
          text:<span>From all of this research, we were able to identify some clear patterns of behavior surrounding the user purchase journey. While there were a lot of different initial events that might kick off a purchase journey, users tended to move through a common series of stages toward making their purchase.</span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"hard-title",
          format:"full-width",
          title:"The Full Journey",
          text:<span>This map shows each of the potential phases of a typical thoroughly-researched beauty purchase decision – these phases were largely universal for most users shopping online. However, we also found that <b2>many users are looking to skip or shortcut some phases of their journey</b2> so this map should be considered a catalogue of the <b2>possible</b2> key phases of decision-making.</span>
        },
        {
          type:"image",
          format:"full-width",
          style:"shadow",
          subType:"plain",
          img:Case_Images["mira_search/decision_making_1.png"]
        },
        {
          type:"text",
          subType:"soft-title",
          format:"half-width",
          title:"Variation 1 – Specific Product Interest",
          text:<span>A common use case for our search tool is one in which users come in already having a specific product that they want to know more about. They may have gotten a product recommendation from a friend or heard about a new product through their media channels and now they want to decide if they're interested enough to give it a try.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          style:"shadow",
          img:Case_Images["mira_search/mira_decision_text_search.png"]
        },
        {
          type:"text",
          subType:"soft-title",
          format:"half-width",
          title:"Variation 2 – Just Browsing",
          text:<span>Beauty enthusiasts spend a significant amount of time just browsing products – this is an important learning & orienting activity for users as they expand their product knowledge & brand familiarity.<br/><br/><b2>Deals Insight! – </b2>During this research we also got our first insight into the opportunity for integrating deals into our platform. As users spend time browsing products, one of the key factors that helps them go from interest to desire is when they find a good deal on a product. This represented a valuable opportunity we would explore in a later design sprint.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          style:"shadow",
          img:Case_Images["mira_search/mira_decision_browsing.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"At the end of a big research cycle, after long hours interviewing, transcribing, and synthesizing, it can be tempting to throw in the towel and want to take a break from it all. But the final step of planning of how to leverage your research is what makes or breaks your designs! Because these user journeys were so core to everything else we worked on, we invested in making some big prints to mount on the wall in our designß conference room. We also used this map as a framework for cataloging the insights, pain points, and opportunities we uncovered each week during our post-launch iteration."
        }
      ]
    },
    {
      WorkType:"Interaction Design",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"half-width",
          title:"The Goal",
          text:"Now that we had some solid research to build on top of we set out to begin designing & testing a new universal search UI – one that was capable of handling both browsing and high-intent search."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/ui_design_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Search – UI Research",
          text:<span>When it comes to designing search engines, there are a lot of different models that have been explored. One important constraint with our search engine was that we're giving people access to a variety of different content types: products, videos, user profiles, etc. Google is the most well-known, but other platforms like Facebook, Instagram, and Apple have also taken unique approaches to multi-modal search UI & results. <br/><br/><b1>Search Interfaces I analyzed:</b1><ul><li>Macbook's Quickfind</li><li>Google Search</li><li>Spotify Search</li><li>Facebook Search</li></ul></span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/search_competitive_research.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Sketch & Whiteboard Explorations",
          text:<span>Because search has such complex mechanic, there was a lot of back & forth sketch exploration among the product team to compare UI concepts and elements. We also spent a lot of time whiteboarding collaboratively with the Dev team to unpack nuanced mechanics, edge-cases, and feasibility.</span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/whiteboard_sketches.jpeg"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Designing Search Results",
          text:<span>The search results page was a big part of the design challenge. We needed to make sure that we were giving people our best guess at the right results enough of the time and presenting those results in a way that is intuitive to navigate. When it came to user searches, we identified 3 primary types of searches: <ul><li><b2>High-intent</b2> – the user is looking for a specific node.</li><li><b2>Need-based</b2> – the user is looking for potential solutions to a specific need</li><li><b2>Open-ended</b2> – the user is just probing & exploring.</li></ul>On the dev side we spent time refining our text-processing to be able to identify which type of search the user was making. Then on the design side we created a search results layout that was optimized for each query type.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_suggestions_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_suggestions_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Search Suggestions",
          text:"While typeahead design might seem straightforward at a glance, there's actually a lot of nuances to it, such as which results to show first, how to differentiate different types of results, and how to balance consistency with flexibility when reacting to different types of searches."
        },
        {
          type:"image",
          format:"full-width-capped",
          style:"shadow",
          subType:"plain",
          img:Case_Images["mira_search/typeahead_design.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Search Filters",
          text:"During our phase of UI testing we had discovered that users in our app didn't tend to be willing to dig into filters on a separate page even though they wanted to be able to filter results. With this design we focused on a more snackable & accessible approach to filters where we brought the most-used filters to the forefront."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/search_filters.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Search Home Tabs",
          text:"The last big part of search had to do with the low-intent browsing – here our strategy focused on two things: 1) creating a number of 'jumping off points' to help lead users toward a new product search and 2) highlighting the best recent content that related to the parts of our ecosystem we knew were important to that user. Of course figuring out what was the 'best' recent content was a design challenge of its own!"
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/search_home_tabs.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"Our search UI design involved a lot of moving parts. Bringing all of these together required a lot more coordination among our team than some of our other design projects because search was the homepage that connected users every other part of our app. We found weekly check-ins & design-dev pairings to be super helpful in keeping communication tight during this period."
        }
      ]
    },
    {
      WorkType:"Prototyping",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"one-third",
          title:"The Goal",
          text:"Now that we had a solid understanding of user's needs & context coming into search, we needed to unpack the specifics – how are they searching? What language do they use? How do they want to be able to sort and filter results? The goal of our prototyping research was to test hypotheses around search UI & text processing to make sure we're responding to users in the right ways."
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"header",
          img:Case_Images["mira_search/prototyping_header.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Search Queries – Research Prototype",
          text:"Designing a universal search required an exploration of what type of queries users wanted to search and how we were able to handle those queries."
        },
        
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["mira_search/mira_search_prototype_laptop.png"]
        },
        {
          type:"text",
          subType:"soft-title",
          format:"one-third",
          title:"Probing for Queries",
          fontSize:"small",
          text:<span>We assigned a group of 40 users from our target audience a 1 hour research project.<br/><br/><b1>Users performed tasks like:</b1><ul><li>Open-ended search for anything beauty-related</li><li>Search for a new product they're hoping to buy</li><li>Find a product from a brand you've never heard of</li><li>Find the products in your current makeup collection</li></ul></span>
        },
        {
          type:"image",
          format:"two-thirds",
          subType:"plain",
          img:Case_Images["mira_search/search_prototype_results_shaded.png"]
        },
        {
          type:"text",
          subType:"soft-title",
          format:"one-third",
          title:"Query Analysis",
          fontSize:"small",
          text:<span>The results & feedback from our text search prototype gave us a much clearer understanding of the landscape of search queries we should expect to handle. Working with our dev team we built a test case collection of queries that we wanted to make sure we were handling correctly before launching our new search. In addition to checking for gaps in our product catalog, we also got to test how our system was handling edge cases like common misspellings or vague searches. </span>
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Browsing Prototype",
          text:<span>While we were testing query searches with the AWS prototype our dev team had built, I was also testing a few different UI hypotheses with interactive prototypes. I built two prototypes to test different functionality. For the types of interaction in this prototype (primarily navigational) Principle made the most sense. (if I were doing this same project in 2021 I'd probably leverage Figma's in-house prototyping toolkit, but it was still buggy at this time)</span>
        },
        {
          type:"image",
          format:"three-fourths",
          subType:"plain",
          img:Case_Images["mira_search/mira_search_principle_angle2.png"]
        },
        {
          type:"image",
          format:"one-fourth",
          subType:"plain",
          img:Case_Images["mira_search/mira_search_ui_prototype1.gif"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Prototype Results",
          text:<span>I ran a series of user interview sessions where we let users browse the prototype and ask questions. From this, I was able to see which types of content users were drawn to and how they felt about some of the new content tabs we were considering within search. Based on the user engagement and feedback we got from these sessions, we concluded that the other content only useful as it relates to the products. Since users were heavily invested in other platforms for looks, articles, and videos, that content didn't add value in our app when not connected to a specific product they're interested in.</span>
        },
        {
          bookEnd:true,
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:<span>Prototyping is always a tricky game of figuring out which parts of the experience or functionality can be simulated effectively & efficiently – and which questions you need to answer to inform your design decisions. You also have to control for the aspects of the experience that are missing – in our case, with our browsing prototype we were only able to feasibly build a few layers deep, so once users reached the end we had to use conversational probing to understand where the user thought they were heading from there.<br/><br/>Additionally, while we're able to see how a user engages with it in a discrete instance, we don't get to see what that interaction looks like over time. While we ended up getting great data on the usability of the UI we only got limited insight into the recurring experience of a social / search platform.</span>
        }
      ]
    },
    {
      WorkType:"Visual Design",
      Content:[
        {
          type:"text",
          subType:"hard-title",
          format:"half-width",
          title:"The Goal",
          text:<span>With much of our core information architecture & UI decisions resolved, we shifted our focus to a visual overhaul of our app. This involved a rebranding as well as beginning to develop our design system & component library. The UI design changes focused on increasing visual clarity within the app and giving more space for product imagery to stand out.<br/><br/><b>Rebranding</b><br/>To ease the design workload during this period we tapped a branding firm to develop logo concepts. Our team took the branding firm's exploratory logo work, refined it, and built a UI kit around it.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/logo_revision.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"UI Redesign",
          text:"This UI redesign focused on enhancing the UI clarity & reducing the business of the interface. As our product direction moved away from some of the more community-centric features we had been exploring, we had an opportunity to clean up our UI to let the product & brand imagery stand out as the core visual elements within the app. We also wanted to embrace some interaction patterns from other functionally similar search interfaces in order to provide a familiar conceptual context for our users."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/search_design_iteration_3.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Mira for Web",
          text:"At this stage of our search redesign we were moving towards our formal product launch, and that meant bringing Mira beyond our iOS Beta and translating the experience to web – we took time to not only clean up the app & phase out lesser-used features, but also to optimize our pages for SEO as we began to focus on improving our organic acquisition."
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["mira_search/search_web_1c.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_web_2c.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_web_3.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Design System & Components",
          text:"With our visual overhaul, we were finally at the point where it made sense for us to start building out the beginnings of a component library in Figma. This was useful for breaking down the system of reusable search nodes, as well as keeping our type, color, and iconography consistent."
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/component_library.png"]
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/component_library_type.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:"Its amazing what a fresh coat of paint can do for a house and the same was definitely true of our app. We came out of our visual overhaul with a much more cohesive and clear UI that felt refined and ready for prime time. With some late nights of work we squeaked in our visual redesign just before our big product launch announcements went out."
        }
      ]
    },
    {
      WorkType:"Testing & Iteration",
      Content:[
        {
          type:"text",
          subType:"no-title",
          format:"half-width",
          title:"The Goal",
          text:<span><h3 style={{marginBottom:"0px"}}><span style={{fontStyle:"italic"}}>"A search engine is never truly finished, as its interface must continue to evolve with its results."</span></h3><span style={{fontSize:".9em", color:"#adb0be"}}> – Me after several weeks of intense search iteration 😪</span><br/><br/>There's certainly not a lot of time to celebrate in the startup world – even less when you've just launched a search engine to the world! Our first few weeks after launching the new version were packed with continued user surveys, analytics breakdowns, and interaction reviews. We fixed, adjusted, and iterated almost every aspect of the UI & text processing algorithms as we discovered new insights & opportunities for improvement.</span>
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/mira_launch.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"User Session Reviews",
          text:<span>Post-launch we shifted away from pixel pushing and back to research to see how our users were engaging with the new search design. Full-story is an amazing tool for this – we spent a good amount of time watching user session videos. <br/><br/><b1>We were able to discover:</b1><ul><li> Usability issues & rage clicks</li><li> UI bugs & errors</li><li> How users are searching</li><li> How users are moving between browsing & high-intent search</li></ul></span>
        },
        {
          type:"image",
          format:"full-width-capped",
          subType:"plain",
          img:Case_Images["mira_search/full_story_big.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Analytics Mining",
          text:<span>Working at Mira was my first time having a team that was truly dedicated to collecting thorough analytics and had the capabilities to do so. We used a platform called metabase that gave non-coders the ability to explore & combine different cuts of our data.<br/><br/>By making the right data cuts accessible, we were able to do weekly reviews of important metrics and it made it easier to see a holistic picture of how our design iterations effected different parts of the user experience.</span>
        },
        /*{
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["mira_search/search_iteration_analytics.png"]
        },*/
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_analytics_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_analytics_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Surveys, Surveys, Surveys!",
          text:"And of course, no research would be complete without a healthy dose of user surveys. Our weekly 'pulse check' surveys helped us keep our ears to the ground on how users felt about new developments and how our NPS score changed week-to-week. Targeted usability & UX surveys helped the design team get more specific insights on our work."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/testing_surveys.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/testing_surveys2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Synthesizing It All",
          text:"It was a lot of data to work with and a big part of the job was finding the right formats to collect, organize, and share it all. We found weekly shareouts to be a great format to kick off the week with new metrics, plus our user journey map gave us a visual way to see which parts of our funnel the pain points & feedback were coming from."
        },
        {
          type:"image",
          format:"full-width",
          subType:"plain",
          img:Case_Images["mira_search/journey_map_pain_points.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_iteration_pain_points.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_iteration_synthesis.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Design Iterations & Visual Refresh",
          text:"In the end, we made a ton of different tweaks to Mira's search design during the weeks of iteration. When it comes to search, small changes to a common component can result in big UX improvements for our users. Some of the adjustments we made to our search results increased our search succcess rate by close to double digits."
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_design_iteration_1.png"]
        },
        {
          type:"image",
          format:"half-width",
          subType:"plain",
          img:Case_Images["mira_search/search_design_iteration_2.png"]
        },
        {
          pageBreak:true,
          type:"text",
          subType:"soft-title",
          format:"full-width",
          title:"Takeaway",
          text:<span>I learned a TON about designing complex interfaces in which design and dev need to be tightly integrated. Half of a search UI exists in the way that the text gets processed, so it required an especially collaborative approach to design.<br/><br/>Additionally, I think I learned a ton about how to effectively set up the right metrics & analytics from working on this project, having those in places makes you feel like you're no longer wandering in the dark, but getting it all set up is a pretty big endeavor that requires some patience & iteration.</span>
        }
      ]
    }
  ]
};







var case_data = {
  book_nation:{
    Type:"case",
    Name:"Bringing Literacy Online",
    Description:"I worked with Savannah, GA non-profit Book Nation to build a digital home-base for their literacy programs. I coached the team on content management and trained them on necessary communication & media tools.",
    Company:"Book Nation",
    ProjectColor:"594BED",
    HeaderType:"Image",
    HeaderSrc:Case_Images["book_nation/book_nation_header_books.png"],
    WorkType:["Storytelling","Web"],
    CaseStudy:BN_Case_Study,
    Brief:"Book Nation made some early headway on several fronts working towards supporting childhood literacy in Savannah. Now they needed to bring their initiatives together into a focused vision for the future of the organization. In addition, Book Nation needed help developing a brand their constituents could trust, and a new website to bring their message to a broader audience.",
    WorkSummary:[
      {
        Title:"Narrative Development",
        Short:"Narrative",
        Description: "Interviewed stakeholders, synthesized themes, and reviewed it all with the team to craft a unified narrative of Book Nation's goals & vision for the organization."
      },
      {
        Title:"Brand Development",
        Short:"Brand",
        Description: "I worked with the team to develop a more mature, prime-time-ready brand for Book Nation. We went through several logo & aesthetic iterations to develop a brand the team was excited about."
      },
      {
        Title:"Web Development & Content",
        Short:"Website",
        Description: "Building on the narrative & branding work we had done, I packaged it all together into a new Wix website for the organization. I worked with the team to develop the copy & outline key site functionality."
      }/*,
      {
        Title:"Pitch Materials",
        Short:"Pitch Deck",
        Description: "I'm currently working with Book Nation to develop pitch materials that the team can present during fundraising events to help investors understand their approach to literacy and the impact they're making in the community"
      }*/
    ]
  },
  fbtb:{
    Type:"case",
    Name:"Making Fruit Local Again",
    Description:"During the pandemic I launched a local produce delivery service in the East Bay connecting Bay Area farmers with local residents. I built the business from the ground up and managed a team making weekly deliveries.",
    Company:"Fruit By The Bay",
    ProjectColor:"594BED",
    HeaderType:"Image",
    HeaderSrc:fbtb_header_img,
    WorkType:["Research","UX","UI","Marketing"],
    CaseStudy:FBTB_Case_Study,
    Brief:<div>The East Bay Area has nearly 10 different farmer's markets that run throughout the year and many of the residents in the East Bay rely on these farmers to get their weekly supply of healthy & local foods. <br/><br/>However, when the pandemic hit, a lot of people lost access to local food. Stuck inside, it became more difficult to make trips out to the local markets. For others, being stuck inside meant they were cooking at home a lot more and needed to figure out how to get quality ingredients while the world was in lockdown. Meanwhile, farmers who normally saw a strong showing at the markets now found themselves struggling to stay connected with customers.<br/><br/><b1>That’s the opportunity that I saw for Fruit by the Bay ~ How could we reconnect people with local farmers & their food products, but do so from a safe distance?</b1></div>,
    WorkSummary:[
      {
        Title:"Market Research",
        Short:"Research",
        Description: "I had a hunch that there was an opportunity for a residential delivery service in the East Bay. I conducted a series of interviews & surveys to evaluate the market opportunity. "
      },
      {
        Title:"The New Client Journey",
        Short:"UI Design",
        Description: "In order to onboard new clients, I crafted & tested a website & sign-up flow that let users express exactly what they were looking to have delivered."
      },
      {
        Title:"Brand Development",
        Short:"Branding",
        Description: "I built a brand for FBTB that included logo development, photography, graphics, and messaging."
      },
      {
        Title:"Marketing & Advertisement",
        Short:"Marketing",
        Description: "I launched several marketing campaigns and tested out different approaches to customer acquisition in order to find the most viable strategies."
      },
      {
        Title:"Operations Development",
        Short:"Operations",
        Description: "I built a delivery operation, solving logistical challenges, building a delivery team, and managing the day-to-day tasks of running the produce delivery business."
      }
    ]
  },
  mira_search:{
    Type:"case",
    Name:"Creating a Search Engine",
    Company:"Mira A.I.",
    ProjectColor:"B4737A",
    Description:"After several weeks conducting exploratory research and testing feature prototypes, we began bringing it all together into a complete beauty search engine. I lead the design of the search system & product interface.",
    /*VideoID:"Xyw2vHd1rx4",*/
    HeaderType:"Image",
    HeaderSrc:Case_Images["mira_search/mira_search_header.png"],
    WorkType:["UX","UI","Testing"],
    CaseStudy:Mira_Search_Case_Study,
    Brief:"Our previous product-discovery research had lead us to the hypothesis that what users wanted was a universal search engine for beauty products. This initiative was about figuring out what the ideal beauty search engine looks like and how it should work in order to enable beauty users to find & evaluate products that fit their individual needs.",
    WorkSummary:[
      {
        Title:"User Journey Research",
        Short:"Research",
        Description: "We began with a thorough round of research to understand the decision-making process that makeup enthusiasts have when searching for a new product."
      },
      {
        Title:"Interaction Design",
        Short:"Interaction",
        Description: "Once we understood how search fit in to the decision-making process, we began designing a search interface. This process invovled a number of collaborative design sessions to balance technical feasibility with design usability."
      },
      {
        Title:"Prototyping",
        Short:"Prototyping",
        Description: "In order to test our hypotheses about search, we developed & tested a series of prototypes in order to refine both our technical search proessing as well as the UI of the search & results pages."
      },
      {
        Title:"Visual Design",
        Short:"Visual",
        Description: "Once we understood how search fit in to the decision-making process, we began designing a search interface. This process invovled a number of collaborative design sessions to balance technical feasibility with design usability."
      },
      {
        Title:"Testing & Iteration",
        Short:"Testing",
        Description: "Building a search engine is a huge design & technical endeavor and this project required a lot of work to analyze the data on how people were using our search engine and iterate based on those results."
      }
    ]
  },
  mira_community:{
    Type:"case",
    Name:"Building a Beauty Community",
    Description:"After seeing increasing user engagement in our community-oriented features, we set out to explore the opportunities within the community-driven space. I co-lead the design of several beauty community features.",
    Company:"Mira A.I.",
    ProjectColor:"594BED",
    HeaderType:"Image",
    HeaderSrc:Case_Images["mira_community/mira_community_header_bg_tiles.png"],
    ComingSoon:true,
    WorkType:["Research","UX","UI"],
    //CaseStudy:Mira_Images,
    Brief:"As we continued to develop our beauty search engine, it became clear that beauty research involved more than just searching through reviews. In order for our platform to truly help our users find the right beauty products & information, we needed to help connect beauty enthusiasts together by creating a space for sharing advice, recommendations, and beauty knowledge.",
    WorkSummary:[
      {
        Title:"Research & Ideation",
        Short:"Research",
        Description: "Conducted early research to inform potential community feature directions. Fleshed out community concepts like Q&A, user reviews, look sharing, and then got feedback from our users to help choose the right starting point."
      },
      {
        Title:"UI Design",
        Short:"UI Design",
        Description: "Created UI designs using Figma for Mira's mobile app & web platform. Worked with development team to evaluate & implement community designs & functionality."
      },
      {
        Title:"Feedback & Iteration",
        Short:"Iteration",
        Description: "We made several rounds of iteration to our community features, ultimately leading to a few refined components: User reviews, Q&A, and community discussions."
      }
    ]
  },
  mira_mvp:{
    Type:"case",
    Name:"Finding our M.V.P.",
    Company:"Mira A.I.",
    ProjectColor:"DD1B82",
    HeaderType:"Image",
    HeaderSrc:Case_Images["mira_mvp/mira_mvp_header.png"],
    ComingSoon:true,
    ThumbHeader:mira_mvp_thumb_header,
    WorkType:["Research","Prototyping","Testing"],
    Description:"The first milestone we worked towards at Mira was finding our Minimum Viable Product. I lead a series of research initiatives to uncover the insights that helped bring our beauty search platform to life.",
    Brief:<span>When I first joined Mira, we didn’t yet know what our product was or what exactly we needed to build to address the problems & opportunity we had identified in the beauty space. So we started by understanding the journey we were designing for and unpacking the problems that beauty enthusiasts faced in their day-to-day lives.<br/><br/>I lead a series of research projects from co-creation labs to prototyping sessions in order to test & iterate different product directions from beauty search to community to social media.</span>,
    WorkSummary:[
      {
        Title:"Product Research",
        Short:"Research",
        Description: "Conducted interviews, lead co-creation labs, and synthesized findings in order to explore & evaluate potential product directions for Mira. Landed on a set of 3 different directions that we continued to vet through prototypes."
      },
      {
        Title:"UI Design & Prototyping",
        Short:"UI Design",
        Description: "Created UI designs using Figma for our different product directions. Worked with development team to evaluate & implement designs & functionality. We built small MVP prototypes of different product directions that we tested with users."
      },
      {
        Title:"Launch, Feedback, Iteration",
        Short:"Iteration",
        Description: "Leading up to the launch, we helped develop an early visual brand for Mira. Once we launched the product in the App store, we conducted follow-up research to understand what was resonating with people and how our product fit into their lives.."
      }
    ]
  },
  autodesk_atlas:{
    Type:"case",
    Name:"Mapping Customer Journeys",
    Company:"Autodesk",
    ProjectColor:"5F5F5F",
    ComingSoon:true,
    Description:"At Autodesk I coached fellow designers, developers, and customer support personnel in collaborative journey mapping methodologies, and lead the design & development of Autodesk’s cloud-based CJM tool.",
    VideoID:"ONksH5eHa_Q",
    WorkType:["Research","UX","UI","Comm."],
    Brief:"While working on Autodesk's Service Design Team, one of my core projects was the design and development of Atlas, our internal journey mapping platform. In 2015 I designed and coded a prototype of Atlas in reponse to a need for a more efficient & collaborative tool for mapping experiences within the Service Design Team. My manager and I pitched our prototype to the design leadership at Autodesk and got funding to launch a production version of Atlas. Fast-forward to 2017 and we had launched our third iteration of Atlas which has now been used by over 800 people at Autodesk to map user experiences across various products and channels within Autodesk's ecosystem.",
    WorkSummary:[
      {
        Title:"User Research",
        Short:"Research",
        Description: "Conducted interviews with Autodesk employees, stakeholders, and customers in order to understand their needs & processes. Presented insights to stakeholders along with recommendations for opportunities for improvement."
      },
      {
        Title:"Concept Exploration",
        Short:"Prototype",
        Description: "Journey-mapping was identified as a key valuable process, but had barriers to its usage within the company. Developed concepts & prototypes to explore different ways of enabling UX research & communication."
      },
      {
        Title:"Product Pitch",
        Short:"Pitch",
        Description: "Ultimately we received interest surrounding the possibility of a web platform for customer journey mapping. We refined our prototype of the tool and pitched to internal stakeholders for funding."
      },
      {
        Title:"Product Design & Development",
        Short:"Design",
        Description: "After recieving funding for the development of our journey mapping platform, Atlas, we contracted a development team who we worked with to build the tool. I led product design of Atlas as well as coding the front-end of the web app."
      },
      {
        Title:"Product Adoption & Promotion",
        Short:"Promotion",
        Description: "Within the company, we led efforts to promote the usage of the platform. We worked with users to explore a variety of use cases for the tool and share those processes with others within the company."
      }
    ]
  }
}









/* t-mobile work summary --> 

Description:"We partnered with design strategy firm The Wrecking Crew to help T-Mobile create an offering for small businesses. The Hellopress team created design assets, planned and ran co-creation projects, and delivered insights to the T-Mobile team by recording research process into a film deliverable.",
    Brief:"T-Mobile realized that when it came to the mobile services market, small businesses were an underserved demographic. The T-Mobile team wanted to understand if there was an opportunity to better serve this audience, and what the ideal services offering could look like.",
WorkSummary:[
      {
        Title:"Product Research",
        Description: "Recruited & interviewed small-business owners to gather initial insights surrounding existing pain points & opportunities."
      },
      {
        Title:"Co-Creation Lab",
        Description: "Planned & executed multiple co-creation sessions involving SMB owners and T-Mobile stakeholders to collaboratively refine the new offerings."
      },
      {
        Title:"Product Development",
        Description: "Turned research insights into concepts to formally pitch new service offerings to T-Mobile executives."
      }
    ]
    
    */









    
    
var pretty_data = {
  Mira:{
    Type:"pretty",
    Title:"Mira A.I. – Beauty Search",
    Project_Type:"Product Design",
    Project_Img:Pretty_Images["Mira/mira_beauty_search.gif"],
    WorkSummary:[],
    Description:<span>At Mira I helped take our beauty search engine from initial concept to product launch and beyond.<br/><br/>I created this GIF to provide a brief visual intro to our app as part of the design of our pitch deck during our 4.5M seed round of funding.</span>,
    IMG:"Mira_MVP_Thumb.png"
  },
  Atlas:{
    Type:"pretty",
    Title:"Atlas Journey Mapping Tool",
    Project_Type:"Product Design",
    WorkSummary:[],
    Description:<span>While working on Autodesk's Service Design Team, one of my core projects was the design and development of Atlas, our internal journey mapping tool. In summer 2015, I designed and built a prototype of Atlas in reponse to a design brief to envision an efficient system for mapping experiences within the Service Design Team.<br/><br/>After my manager and I pitched the prototype to Autodesk stakeholders, we got funding to launch a production version of Atlas. I worked with Autodesk for two years launching & iterating the Atlas tool which has now been used by over 800 people at Autodesk to create journey maps of complex user flows between Autodesk's suite of 80 different products.</span>,
    Video_ID:"_vh8okAjmZg"
  },
  Tin_Pan:{
    Type:"pretty",
    Title:"Tin Pan",
    Project_Type:"Interaction Design",
    WorkSummary:[],
    Description:"I worked with app developer Gil Carmel to create Tin Pan – an app for learning music theory, song composition, and musical imrpovisation. I created the visual & interaction designs for the app, as well as developing a promotional video, website, and other design assets.",
    Video_ID:"Xyw2vHd1rx4"
  },
  T_Mobile:{
    Type:"pretty",
    Title:"T-Mobile Co-Creation",
    Project_Type:"Research Lab",
    WorkSummary:[],
    Description:<span>For Small Business Unlimited I was hired by The Wrecking Crew, headed by Haakon Faste and David Fetherstonhaugh, to help run and document two design co-creation sessions with small business owners.<br/><br/>I lead a team of 3 to help The Wrecking Crew facilitate the sessions and synthesize feedback from the participants. Ultimately my team delivered a concept video to the client communicating the experience and details of 3 potential small business offerings based on our findings.</span>,
    Video_ID:"NvdAJC_ZDIU"
  },
  Playpen:{
    Type:"pretty",
    Title:"Playpen – Smart Dog Toy",
    Project_Type:"Product Design",
    WorkSummary:[],
    Description:"Woof! Playpen is a concept for a new type of dog-human play experience that I researched, developed, and pitched to investors for Christina Wodtke’s Creative Founder class at CCA. The concept riffs off of the Sphero robotic ball and introduces the playpen smart hub to create a game that can be played between the human and dog in the home.",
    Video_ID:"4OFSBCSSTlE"
  },
  EM:{
    Type:"pretty",
    Title:"EM – Emotive Journal",
    Project_Type:"Product Design",
    WorkSummary:[],
    Description:<span>Today's world is complex. Even just managing our interpersonal relationships can be tough. Journaling has been proven to be an effective tool for reflection & instrospection that helps us keep up with our increasingly busy lives. EM provides an accessible, conversational web platform that makes journaling easy.<br/><br/>I designed and coded EM, a platform for conversational journaling and created this promo video to convey the user experience of EM to someone new.</span>,
    Video_ID:"jqxYS-ToVDo"
  },
  MADA:{
    Type:"pretty",
    Title:"Make America Doodle Again",
    Project_Type:"Game Design",
    WorkSummary:[],
    Description:<span>A social drawing game where you and a buddy both draw a different presidential candidate's stance on a political issue. You then have one minute to draw and then guess each other’s drawings.<br/><br/>I created the origintal concept for the game and designed and developed the digital desktop & mobile version of the game. I worked with several other designers to develop branding & launch a series of events for people to play the game in-person throughout San Francisco leading up to the 2016 election.</span>,
    Video_ID:"ZsqKt6jy020"
  },
  Munchbox:{
    Type:"pretty",
    Title:"Munchbox – Concept",
    Project_Type:"Speculative Design",
    WorkSummary:[],
    Description:"Munchbox is the outcome of industry research, future forecasting, and critical design surrounding the evolution of advertising. I worked with a team of designers to model advertising mechanisms, noting key paradigm shifts, and ultimately projecting those changes into the future. We created a short film to illustrate this future in order to get reactions from people about this potential reality.",
    Video_ID:"qmvHJ1h3518"
  },
  Like_Detector:{
    Type:"pretty",
    Title:"Like Detector – Concept",
    Project_Type:"Speculative Design",
    WorkSummary:[],
    Description:<span>The like detector is a satirical take on today's social media landscape. The product concept provokes the question that many of us have in the back of our mind as we take photos these days – am I doing this for me or for the internet?<br/><br/>The concept is an app + selfie-stick that uses predictive ML to provide an estimate of potential likes a photo could get. The model is trained on previous posts to identify similarities that correspond to higher like data, giving the user a more expedited path toward reaching their social goals.</span>,
    Video_ID:"XGzKhLUcUn0"
  },
  Stubble_Upon:{
    Type:"pretty",
    Title:"Stubble Upon",
    Project_Type:"Product Concept",
    WorkSummary:[],
    Description:<span>Scrolling is on the rise as computers continue to become the defacto hub for a growing variety of our passive consumption, from browsing news feeds to reading books & articles.<br/><br/>StubbleUpon is an experimental computer interface embeded in a wearable beard that pairs the subconscious activity of 'stroking one's beard' to the digital act of scrolling & other key computer interactions. Using a variety of arduino sensors (conductive thread, accelerometer, etc.) we turned this beard into a computer interface optimized for scrolling & other passive interactions.</span>,
    Video_ID:"03Y5TwM3Nvg"
  },
  Moon_Sine:{
    Type:"pretty",
    Title:"Moon Sine Constellations",
    Project_Type:"Interactive Art",
    WorkSummary:[],
    Description:<span>MoonSine is an interactive art project I built as a Javascript experiment in 2010 to explore new Canvas element that was introduced in HTML5. The project is simple – a random constellation of stars is generated on the page and the user may click from star to star to draw constellations.<br/><br/>MoonSine aims to recreate the experience our ancestors had when they looked up at the stars above. What makes it interesting are the constraints of having a fixed set of line endpoints (the star positions) and the fact that your drawing must be made as one continuous line starting from wherever your last endpoint was.</span>,
    Video_ID:"Mpnuf8SBFmg"
  },
  Dirt_Dealer:{
    Type:"pretty",
    Title:"Dirt Dealer",
    Project_Type:"Design Concept",
    WorkSummary:[],
    Description:<span>Dirt Dealer is a concept for a community garden compost-exchange service designed for apartment complexes. The concept brings together 3 types of personas to create a symbiotic exchange of fresh produce and high quality compost.<br/><br/>A big portion of sustainability comes down to individual behaviors & habits – this design creates a positive feedback loop where each type of user is incentivized to develop sustainable habits that fit in with their lifestyle. Community gardeners get to sell their excess produce to other residents, casual gardeners get opportunities to volunteer in the garden, and all residents are rewarded with produce credits for contributing their household compost.</span>,
    Project_Img:Pretty_Images["Dirt_Dealer/dirt_dealer.png"]
  },
  Cafe_Blank:{
    Type:"pretty",
    Title:"Cafe Blank",
    Project_Type:"Experience Concept",
    WorkSummary:[],
    Description:<span>I worked with designers Alessandro Battisti and Colin Swenson to create Cafe Blank – a design experiment to activate underused public spaces in San Francisco.<br/><br/>In 2017 we launched a prototype experience of Cafe___, a pop-up art event which gives artists a chance to bond with locals and simultaneously introduces new community art to improve underused, dirty, and ugly public spaces in San Francisco. We launched our prototype in an unused alleyway off of Valencia street and were pleased to see significant interest from the local community.</span>,
    Project_Img:Pretty_Images["Cafe_Blank/cafe_blank.png"]
  },
  Evolution:{
    Type:"pretty",
    Title:"Evolutionary Systems",
    Project_Type:"Poster",
    WorkSummary:[],
    Description:<span>This poster is the first in a three part series & designed to highlight key evolutionary systems & principles that guided the narrative of our planet's organic evolution of life.<br/><br/>I've always found evolution to be such a fascinating phenomenon and as a designer I think there's so much we can learn by studying it's processes. I've found these principles can be applied throughout the design process when creating constraints for ideation, or designing feedback loops within a social platform or game.</span>,
    Project_Img:Pretty_Images["Evolution/evolution.png"]
  },
  Device_6:{
    Type:"pretty",
    Title:"Device 6 Breakdown",
    Project_Type:"Poster",
    WorkSummary:[],
    Description:<span>This poster is a visual breakdown of one of my favorite games ever: Device 6 is a hybrid narrative & puzzle game.<br/><br/>The game creators walk the player through a complex & super-meta story by completing a series of puzzles. In order to complete each level, the user must read back and forth through the narrative to pick up clues. This was a fun visual experiment to try and design a visual representation of the key mechanics & narrative progression of the game.</span>,
    Project_Img:Pretty_Images["Device_6/device_6.png"]
  },
  Auquip:{
    Type:"pretty",
    Title:"Auquip Refillable Drinks",
    Project_Type:"Product Concept",
    WorkSummary:[],
    Description:"Isn't it crazy that so many of our drinks come in single-use bottles that are actually perfectly capable of re-use? Auquip is a product concept I explored for a refillable beverage. Instead of a pre-mixed drink, this bottle comes with pop-able flavor pods embedded in the side of the bottle. When the user finishes the bottle, they simply refill with water, pop a new flavor pod, and then shake.",
    Project_Img:Pretty_Images["Auquip/auquip.png"]
  },
  Food_Obsessions:{
    Type:"pretty",
    Title:"Food Obsessions Poster",
    Project_Type:"Poster",
    WorkSummary:[],
    Description:"This poster is a fun visual catalog of some of the various food obsessions I engaged in when I was younger. Its satisfying to see my progression starting from things like candy & orange juice when I was a kid towards healthier foods like greek yogurt.",
    Project_Img:Pretty_Images["Food_Obsessions/food_obsessions.png"]
  },/*
  AMC:{
    Type:"pretty",
    Title:"AMC Kiosk",
    Project_Type:"Interface Concept",
    WorkSummary:[],
    Description:"The first milestone we worked towards at Mira was finding our Minimum Viable Product. I lead several research initiatives that uncovered insights which ultimately brought our product to life.",
    IMG:"Building_Community_Thumb.png"
  },
  Southbound:{
    Type:"pretty",
    Title:"Southbound Game",
    Project_Type:"Interactive Game",
    WorkSummary:[],
    Description:"The first milestone we worked towards at Mira was finding our Minimum Viable Product. I lead several research initiatives that uncovered insights which ultimately brought our product to life.",
    IMG:"Building_Community_Thumb.png"
  },*/
  Perceptual_Computing:{
    Type:"pretty",
    Title:"Perceptual Computing Poster",
    Project_Type:"Poster",
    WorkSummary:[],
    Description:"I created this concept poster in 2013 to unpack the developing field of perceptual computing – I wanted to create a fun way for people to understand the way that computers were evolving to enable two-way conversation as well as to convey some of the key design principles in perceptual computing.",
    Project_Img:Pretty_Images["Perceptual_Computing/perceptual_computing.png"],
  }/*,
  Like_Detector:{
    Type:"pretty",
    Title:"Like Detector",
    Project_Type:"Tech Satire",
    WorkSummary:[],
    Description:"The first milestone we worked towards at Mira was finding our Minimum Viable Product. I lead several research initiatives that uncovered insights which ultimately brought our product to life.",
    Video_ID:"XGzKhLUcUn0"
  },
  HMW:{
    Type:"pretty",
    Title:"How Might We?",
    Project_Type:"Design Concept",
    WorkSummary:[],
    Description:"The first milestone we worked towards at Mira was finding our Minimum Viable Product. I lead several research initiatives that uncovered insights which ultimately brought our product to life.",
    Video_ID:"O5KLhV5dRpg"
  }*/
}










////////////////////////////////////
// EXTRA FUNCTIONS /////////////////
////////////////////////////////////


function setURL(pageName){
  console.log('Setting URL...'+pageName);
  window.history.pushState({
    id: pageName
  }, pageName+' | Hellopress', pageName);
}






window.addEventListener("load", function(){
  //document.getElementById("App-header-video").play();
  //document.getElementById("App-header-video").classList.remove('wait');
  /*document.getElementById("App-header-video").addEventListener('loadeddata', function() {
    
  }, false);*/
});



  function setup_titles(){
    var elements = document.querySelectorAll('h1');
    for (var i = 0; i < elements.length; i++) {
      var elem = elements[i];
      var array = [];
      for(var j = 0, childs = elem.childNodes; j < childs.length; j ++) {
        if (childs[j].nodeType === 3 /* document.TEXT_NODE */) {
          array = array.concat(childs[j].nodeValue.trim().split(/\s+/));
        } else {
          array.push(childs[j].outerHTML);
        }
      }
      var new_text = "";
      for(var k = 0; k < array.length; k++) {
        new_text += ("<span>"+array[k]+"</span> ");
      }
      elem.innerHTML = new_text;
    }
  }





  var elements;
  var windowHeight;

  function init() {
    windowHeight = window.innerHeight;
  }


  window.addEventListener('resize', init);
  //this.checkPosition.bind(this);
  init();




  //get browser width
  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }


  

  function fade_in_sketch(thisClass){
    for (var i = 1; i < 15; i++) {
      var element_class_name = String("T_"+i);
      //console.log(element_class_name);
      var elements = document.getElementsByClassName(element_class_name);
      if(elements.length > 0 && elements !== undefined){
        var element = elements[0];
        do_set_timeout(element, i);
      }

      element_class_name = String("O_"+i);
      elements = document.getElementsByClassName(element_class_name);
      if(elements.length > 0 && elements !== undefined){
        element = elements[0];
        do_set_timeout(element, i);
      }
      
      element_class_name = String("A_"+i);
      elements = document.getElementsByClassName(element_class_name);
      if(elements.length > 0 && elements !== undefined){
        element = elements[0];
        do_set_timeout(element, i);
      }

    }
  }

  function do_set_timeout(element, i){
    var time_multiplier = i;
    if(i>11){
      time_multiplier +=3;
    }
    if(i>13){
      time_multiplier +=5;
    }
    setTimeout(function(){ 
      element.classList.add('sketch_visible');
      element.classList.remove('sketch_hidden');
    }, 130*time_multiplier+500);
    /*setTimeout(function(){ 
      element.classList.remove('SVGTEXT');
    }, 200*time_multiplier+300);*/
  }
  


  var portrait2_code = (<svg class="portrait_svg" width="720" height="641" viewBox="0 0 720 641" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="394.844" cy="402.981" r="202.047" fill="#FF39B9"/>
<rect id="blue_square" x="539.309" y="216.371" width="109.675" height="109.675" rx="6" transform="rotate(15 539.309 216.371)" fill="#0DC5FF"/>
<g id="square_planet">
<rect width="43.9811" height="43.9811" rx="4" transform="matrix(-0.866025 0.5 0.5 0.866025 167.85 165.242)" fill="#2A2D31"/>
<path d="M176.084 178.767C180.442 177.848 183.543 178.118 184.517 179.806C186.714 183.612 177.255 193.188 163.388 201.194C149.521 209.2 136.498 212.605 134.3 208.798C133.326 207.111 134.642 204.29 137.617 200.975" stroke="#C7D0DC" strokeWidth="2"/>
<path d="M176.084 178.767C180.347 177.683 183.325 177.742 184.166 179.197C186.062 182.481 176.357 191.634 162.49 199.64C148.624 207.646 135.845 211.474 133.949 208.19C133.109 206.734 134.547 204.126 137.617 200.975" stroke="#C7D0DC" strokeWidth="2"/>
</g>
<path id="yellow_triangle" d="M129.127 301.152C130.721 295.203 138.157 293.211 142.511 297.565L290.783 445.837C295.138 450.192 293.146 457.628 287.197 459.222L84.6539 513.493C78.7053 515.087 73.262 509.644 74.8559 503.695L129.127 301.152Z" fill="#F6B40C"/>
<mask id="mask0" maskType="alpha" maskUnits="userSpaceOnUse" x="157" y="118" width="411" height="523">
<path d="M540.987 524.827C531.733 601.944 469.903 635.362 342.246 640.427C234.438 640.427 160.301 598.424 172.875 512.34C172.875 434.499 154.6 395.852 158.388 314.137C165.115 169.046 203.297 118.676 341.51 118.676C474.292 118.676 549.305 155.241 565.799 286.292C576.143 368.477 540.987 441.556 540.987 524.827Z" fill="#FFF"/>
</mask>
<g mask="url(#mask0)">
<path d="M292.755 397.322C295.499 393.058 296.607 364.06 298.176 351.057C299.255 342.118 297.136 327.724 295.443 319.031C293.728 319.61 289.543 320.595 286.528 319.9C282.759 319.031 278.99 320.19 273.192 311.492C267.393 302.795 269.133 303.085 268.553 294.387C267.973 285.69 266.234 285.4 267.103 281.051C267.973 276.702 267.684 273.224 273.192 271.195C277.598 269.571 308.851 230.509 323.927 211.18L412.932 215.819L421.05 266.555L416.701 284.53C417.185 289.362 417.861 300.476 416.701 306.274C415.846 310.553 411.399 320.933 408.208 329.973C405.994 336.246 404.808 341.874 404.095 344.368C400.276 357.735 391.247 375.901 387.449 379.067C386.903 380.372 386.141 382.981 386.323 386.048C386.702 392.441 393.492 397.876 398.346 400.35C403.199 402.823 413.457 408.657 414.562 410.432C415.666 412.207 413.009 425.269 385.295 439.48C357.582 453.69 341.629 454.236 317 444.179C292.371 434.122 282.616 414.82 282.472 410.175C282.329 405.529 290.01 401.587 292.755 397.322Z" fill="white"/>
<path opacity="0.6" d="M329.499 315.5C311.999 313.501 308.168 297.664 304.501 301.997C300.486 305.999 309.5 323.5 310.5 337C312.014 357.434 316.499 350.5 320.999 337C325.3 324.097 338.344 316.51 329.499 315.5Z" fill="url(#paint0_linear)"/>
<path d="M278.422 406.461C281.437 403.446 287.217 401.339 289.729 400.663C287.603 402.595 283.409 407.215 283.641 410.23C283.931 413.999 289.729 426.755 300.746 434.583C311.763 442.411 332.637 451.398 351.192 449.949C369.747 448.499 388.591 438.352 400.478 429.365C412.365 420.377 414.974 413.999 414.974 411.39C414.974 408.78 408.886 406.461 404.247 403.562C400.536 401.242 395.356 398.343 393.23 397.184C394.39 397.667 398.101 398.865 403.667 399.793C410.625 400.953 419.033 408.49 432.079 411.39C445.126 414.289 459.332 424.146 485.134 434.003C510.937 443.86 523.114 447.919 532.101 462.415C541.089 476.911 543.408 507.063 539.639 546.782C535.87 586.5 542.538 629.988 547.757 667.098C551.932 696.785 549.496 746.729 547.757 767.989L158.106 789.733C157.526 779.103 156.309 753.261 156.077 734.939C155.787 712.035 160.715 678.694 161.295 664.778C161.875 650.862 165.064 619.841 165.644 607.664C166.224 595.488 169.413 565.336 169.993 550.261C170.573 535.185 173.472 508.222 174.921 499.815C176.371 491.407 179.56 469.083 180.43 465.894C181.3 462.705 181.01 459.516 190.867 447.919C200.724 436.323 213.771 429.654 226.237 426.465C238.703 423.276 258.128 414.869 264.506 411.68C270.884 408.49 274.653 410.23 278.422 406.461Z" fill="#2A2D31"/>
<path d="M481.663 486.55C468.609 481.758 437.075 464.692 422.939 456.758C447.429 474.419 463.18 483.411 470.916 490.778C474.742 494.421 473.875 500.23 476.512 501.451C479.694 502.925 478.534 494.956 484.468 494.956C488.589 494.879 496.15 502.618 498.489 502.112C498.319 498.921 494.717 491.342 481.663 486.55Z" fill="white" fillOpacity="0.2"/>
<path d="M234.008 492.512C239.712 489.138 253.968 478.81 259.885 473.957C245.117 489.081 238.399 492.481 234.99 494.875C232.263 496.79 232.014 504.027 229.716 504.044C229.694 507.587 228.304 495.887 234.008 492.512Z" fill="white" fillOpacity="0.2"/>
<path d="M474.426 604.964C473.513 597.051 472.235 578.853 474.426 569.359C477.165 557.49 478.534 549.274 471.687 538.775C466.21 530.376 457.537 524.624 453.885 522.798C461.645 525.993 477.804 533.662 480.36 538.775C481.121 535.275 483.373 526.724 486.295 520.516C485.382 525.385 484.103 535.853 486.295 538.775C488.226 541.35 492.664 538.203 495.356 535.649C495.711 535.277 496.041 534.949 496.337 534.666C496.048 534.973 495.718 535.306 495.356 535.649C491.876 539.287 485.875 547.05 483.556 555.664C480.36 567.533 486.751 575.293 483.556 583.509C480.999 590.083 478.839 603.594 478.078 609.528L474.426 604.964Z" fill="white" fillOpacity="0.2"/>
<path d="M232.038 598.572C232.951 590.66 234.229 572.462 232.038 562.967C229.299 551.098 227.93 542.882 234.777 532.383C240.254 523.984 240.254 511.842 243.906 510.016C236.146 513.211 228.66 527.27 226.104 532.383C225.343 528.883 222.759 524.166 226.104 516.406C221.082 522.797 223.274 529.461 221.082 532.383C220.229 533.521 217.511 531.199 215.171 528.778C215.013 528.596 214.853 528.429 214.692 528.275C214.849 528.442 215.009 528.61 215.171 528.778C218.137 532.176 220.481 540.258 222.908 549.273C226.104 561.141 219.713 568.901 222.908 577.118C225.465 583.691 227.625 597.202 228.386 603.137L232.038 598.572Z" fill="white" fillOpacity="0.2"/>
<path d="M338.552 388.485C331.955 376.907 330.819 378.821 324.922 372.641C320.739 368.256 312.117 359.886 309.825 357.668C309.623 357.478 309.433 357.294 309.256 357.117C309.256 357.117 309.46 357.314 309.825 357.668C315.219 362.73 329.458 372.312 337.261 375.726C345.486 379.325 354.741 382.923 365.537 384.466C376.78 386.072 383.53 382.549 387.54 378.971C385.719 383.223 386.224 386.591 386.901 388.946C387.625 391.469 394.034 397.851 397.601 404.344C401.167 410.838 407.753 418.92 402.126 431.796C397.625 442.096 365.023 448.669 356.283 449.697C359.791 448.841 364.728 442.779 359.797 429.861C353.634 413.714 341.302 424.685 339.548 415.928C337.793 407.171 346.798 402.957 338.552 388.485Z" fill="#2A2D31" fillOpacity="0.3"/>
<path d="M294.662 315.261C296.356 322.856 299.432 340.646 298.176 351.049C296.606 364.052 295.278 393.054 292.533 397.318C289.788 401.583 284.124 404.507 283.793 409.143C283.279 416.34 292.371 434.114 317 444.171C341.628 454.229 356.819 454.105 384.532 439.894C412.246 425.684 415.666 412.199 414.562 410.424C413.457 408.649 403.199 402.815 398.345 400.342C393.492 397.868 386.702 392.434 386.323 386.04C386.141 382.973 387.098 380.114 387.644 378.81" stroke="#2A2D31" strokeWidth="0.6"/>
<path d="M288.171 309.546C286.563 309.032 284.465 307.496 283.617 306.792C287.293 309.809 293.967 309.729 290.264 307.582C287.301 305.864 286.658 302.344 286.706 300.798C286.661 302.247 288.317 304.91 289.739 305.825C291.16 306.74 292.564 308.234 291.649 309.656C290.734 311.077 290.182 310.19 288.171 309.546Z" fill="#BFC0C1"/>
<path d="M273.157 307.338C271.564 306.359 270.87 303.205 270.723 301.75C271.069 303.018 272.393 305.805 274.914 306.813C278.065 308.072 279.252 307.24 281.506 309.341C283.76 311.442 285.444 313.236 288.342 313.327C289.791 313.373 291.24 313.418 291.566 312.268C291.756 311.599 291.437 310.234 291.358 309.651C291.826 310.149 292.635 311.49 292.127 312.866C291.493 314.586 286.848 314.73 283.452 312.013C280.057 309.295 275.149 308.561 273.157 307.338Z" fill="#BFC0C1"/>
<path opacity="0.5" d="M275.685 289.96C275.587 289.873 275.51 289.792 275.453 289.719C275.526 289.764 275.603 289.847 275.685 289.96C276.385 290.579 278.146 291.457 281.203 291.35C285.559 291.197 286.709 291.523 287.523 293.289C288.338 295.055 285.639 297.871 283.321 297.798C281.002 297.725 278.212 303.439 281.616 305.866C279.214 305.404 278.248 302.279 278.294 300.831C278.407 297.246 281.889 297.173 278.504 294.166C277.053 292.877 276.245 290.726 275.685 289.96Z" fill="#2A2D31"/>
<path d="M269.887 273.003C268.465 275.182 265.981 281.002 267.421 286.849C269.221 294.157 267.889 299.626 268.92 303.719C269.952 307.813 276.596 317.884 282.355 319.226C288.114 320.567 291.9 320.106 294.544 319.029" stroke="#2A2D31" strokeWidth="0.6"/>
<path opacity="0.8" d="M271.842 275.385C274.646 274.777 279.046 279.963 280.896 282.631C279.855 281.922 277.37 280.374 275.762 279.86C273.752 279.216 271.733 278.863 271.895 282.929C272.025 286.181 270.498 293.52 269.718 296.783C270.296 293.804 271.178 287.257 270.092 284.902C268.735 281.959 268.338 276.145 271.842 275.385Z" fill="#2A2D31"/>
<path d="M389.867 267.284C386.01 266.508 388.357 262.438 391.16 261.436C395.366 259.932 402.301 259.824 408.333 261.976C413.158 263.699 414.795 268.068 415.01 270.038C414.108 269.355 411.205 267.628 406.814 266.181C401.326 264.373 393.724 268.059 389.867 267.284Z" fill="#2A2D31"/>
<path d="M343.749 256.191C333.368 254.936 324.028 260.598 320.656 263.586C323.769 263.2 333.554 262.542 343.503 264.015C355.939 265.857 360.755 264.848 360.847 261.951C360.938 259.053 356.725 257.76 343.749 256.191Z" fill="#2A2D31"/>
<path d="M377.391 320.158C369.567 319.911 367.89 320.219 365.856 320.358C363.821 320.488 362.381 321.27 360.235 320.738C360.235 320.738 362.128 322.694 367.063 322.097C371.998 321.5 372.065 322.097 377.391 322.097C382.066 322.097 387.721 321.954 389.17 319.038C389.652 318.069 390.398 315.254 389.17 312.644C386.851 307.716 385.402 302.093 384.532 299.484C383.589 296.654 381.956 290.93 380.472 285.856C380.864 288.769 381.358 290.484 382.595 295.396C384.142 301.536 384.821 304.107 385.625 309.723C386.284 314.324 384.425 320.379 377.391 320.158Z" fill="#2A2D31"/>
<path d="M356.444 315.151C355.818 312.589 356.97 310.136 358.639 308.6C354.779 311.921 354.966 313.003 355.12 315.126C355.243 316.825 357.725 318.899 358.73 319.726C358.229 319.268 357.071 317.714 356.444 315.151Z" fill="black" fillOpacity="0.2"/>
<path d="M307.073 253.098C306.629 254.921 306.564 260.508 302.607 268.273C297.66 277.98 302.42 278.41 300.086 284.663C298.094 290.002 295.781 301.641 293.588 306.793C293.833 305.157 294.225 301.302 293.835 298.969C293.444 296.636 292.663 299.319 292.322 300.952C291.981 299.491 291.372 296.107 291.662 294.26C291.952 292.412 290.407 294.22 289.597 295.355C289.833 294.009 290.259 290.909 290.079 289.279C289.91 287.761 288.446 289.606 287.587 290.939C287.526 291.047 287.465 291.144 287.407 291.225C287.463 291.134 287.523 291.038 287.587 290.939C287.948 290.293 288.265 289.238 287.489 288.617C286.357 287.711 284.963 285.927 284.765 283.02C284.566 280.113 286.978 265.546 285.266 264.622C283.555 263.698 281.572 262.185 278.348 263.244C275.769 264.091 274.901 265.262 274.789 265.742C274.865 263.328 275.334 257.638 276.603 254.197C278.188 249.896 273.335 247.423 273.463 243.366C273.591 239.309 275.982 237.064 273.809 232.354C272.072 228.587 270.472 227.802 269.889 227.88C270.88 227.138 272.773 224.723 272.427 220.999C271.993 216.345 272.301 215.774 274.457 211.781C276.613 207.788 277.708 209.853 277.827 206.086C277.946 202.319 276.887 199.095 281.27 198.073C285.374 197.116 280.063 196.371 279.452 193.664C277.768 192.723 279.466 190.87 279.397 193.083C279.39 193.286 279.41 193.479 279.452 193.664C280.193 194.078 281.592 194.316 284.088 193.951C292.247 192.757 293.171 191.046 292.972 188.139C292.774 185.232 289.31 186.491 300.086 185.09C310.863 183.689 301.836 179.703 304.902 175.297C308.441 170.209 311.93 182.552 312.357 179.459C313.607 170.418 318.13 174.226 320.391 173.04C318.214 174.615 319.266 180.885 322.581 179.459C332.254 175.297 324.771 170.33 326.665 165.459C328.558 160.587 331.905 160.741 338.271 161.232C344.637 161.722 347.128 159.571 353.747 161.229C360.366 162.888 360.37 162.295 369.624 163.166C378.879 164.038 380.959 168.938 382.281 173.04C391.476 168.486 391.092 177.513 394.41 175.297C398.558 172.527 399.163 177.309 401.625 182.028C404.087 186.746 406.611 180.711 407.634 185.094C408.656 189.477 414.659 192.276 415.618 198.688C416.576 205.099 415.652 206.811 419.31 210.407C422.967 214.002 420.149 215.983 419.695 221.19C419.241 226.397 419.483 234.322 419.31 239.828C419.136 245.333 420.078 254.624 421.454 256.988C422.515 258.812 424.297 258.996 424.79 261.101C424.892 261.164 424.967 261.259 424.833 261.309C424.835 261.32 424.837 261.33 424.839 261.341C424.829 261.332 424.819 261.324 424.81 261.317C424.743 261.336 424.636 261.346 424.474 261.341C423.315 261.304 422.733 262.23 423.388 262.927C422.253 262.118 423.016 263.396 422.936 265.946C422.836 269.133 422.026 271.546 420.486 274.398C419.254 276.68 416.816 282.525 416.767 284.071C416.636 283.631 416.536 283.471 416.468 283.434C416.327 283.794 416.33 283.358 416.468 283.434C416.535 283.263 416.634 282.914 416.767 282.246C417.456 278.787 419.231 277.683 418.2 273.59C417.168 269.496 411.082 258.957 409.236 253.098C407.39 247.238 403.792 242.875 399.5 241C395.208 239.125 393.334 240.12 390.5 238C390.738 239.651 392.956 241 395 242C396.5 242.734 397.5 243.16 400 243.16C397.5 243.923 395 243.923 391.476 243.16C384.582 241.666 377.297 230.532 373.286 228.955C369.275 227.379 363.279 233.571 364.338 236.795C365.185 239.374 368.215 242.622 369.624 243.923C367.216 243.654 361.781 242.458 359.311 239.828C359.187 240.694 359.218 244.523 360.333 245.95C361.727 247.735 345.167 237.642 342.461 231.466C339.754 225.289 333.225 224.76 330.065 223.79C330.565 226.32 328.841 235.505 322.581 242.734C316.415 249.852 308.587 252.572 307.136 253.076L307.073 253.098Z" fill="#2A2D31" fillOpacity="0.25"/>
<path d="M310.363 249.623C309.919 251.446 308.041 257.034 304.084 264.799C299.138 274.505 299.427 274.514 299.507 281.188C299.571 286.527 295.202 298.166 293.009 303.318C293.254 301.682 293.646 297.827 293.255 295.494C292.865 293.162 292.084 295.844 291.743 297.477C291.402 296.016 290.793 292.632 291.083 290.785C291.373 288.938 289.828 290.746 289.018 291.88C289.254 290.534 289.68 287.434 289.5 285.804C289.331 284.286 287.867 286.131 287.008 287.465C286.947 287.573 286.886 287.669 286.828 287.751C286.884 287.659 286.944 287.563 287.008 287.465C287.369 286.819 287.686 285.763 286.91 285.143C285.778 284.237 284.384 282.452 284.185 279.546C283.987 276.639 281.76 273.668 280.049 272.744C278.337 271.82 276.355 270.307 273.131 271.366C270.551 272.213 269.683 273.385 269.571 273.864C269.647 271.45 270.116 265.76 271.385 262.319C272.971 258.018 268.117 255.545 268.245 251.488C268.373 247.431 270.764 245.186 268.592 240.477C266.854 236.709 265.254 235.924 264.672 236.002C265.662 235.26 267.556 232.845 267.209 229.122C266.775 224.467 267.083 223.897 269.239 219.904C271.395 215.911 272.491 217.975 272.609 214.208C272.728 210.441 271.669 207.217 276.052 206.195C280.435 205.173 274.079 204.392 274.179 201.205C274.279 198.017 275.349 191.67 283.508 190.476C291.668 189.283 292.592 187.572 292.393 184.665C292.195 181.758 294.316 173.511 305.093 172.11C315.869 170.709 319.6 171.986 317.644 169.604C315.689 167.222 310.528 165.319 311.778 162.458C312.778 160.169 317.551 157.225 319.812 156.04C317.635 157.615 313.899 161.423 316.369 164.053C319.456 167.341 321.158 168.555 323.052 163.683C324.946 158.812 328.062 157.747 334.428 158.237C340.794 158.728 339.537 152.597 346.156 154.256C352.775 155.914 354.576 157.425 363.83 158.296C373.085 159.168 378.734 163.987 380.055 168.089C382.006 167.57 386.735 171.777 390.054 169.561C394.202 166.791 400.142 171.512 402.604 176.23C405.066 180.949 412.498 180.679 413.52 185.062C414.543 189.445 417.949 185.9 418.908 192.312C419.866 198.723 418.942 200.434 422.599 204.03C426.257 207.626 424.84 214.429 424.356 217.33C424.115 218.781 424.356 219.748 425.324 219.748C426.291 219.748 427.284 218.466 427.258 218.781C426.774 220.716 425.324 222.65 423.771 222.166L423.949 225.068C424.357 228.589 425.324 232.292 425.324 233.773C425.324 236.143 426.26 237.481 426.291 238.126C426.322 238.77 424.16 236.186 424.144 236.675C423.971 242.181 422.629 246.762 424.144 253.602C425.324 258.921 426.774 260.856 429.193 264.725C428.344 264.021 426.291 262.79 424.84 262.79C423.68 262.79 425.851 266.445 426.506 267.143C425.371 266.334 422.019 266.044 421.938 268.594C421.838 271.781 420.3 277.161 418.76 280.013C417.528 282.295 417.122 285.956 417.074 287.502C416.549 285.745 415.637 281.539 416.188 278.772C416.877 275.313 418.652 274.208 417.621 270.115C416.589 266.022 412.055 253.406 410.209 247.547C408.363 241.688 406.292 233.375 402 231.5C397 229.315 390.454 230.102 387.62 227.982C387.858 229.633 389.434 233.028 393.831 233.399C398.229 233.769 400.511 233.125 401.103 232.757C400.007 233.786 396.432 235.569 390.897 234.466C383.979 233.088 376.718 224.158 372.707 222.581C368.696 221.005 362.7 227.197 363.759 230.421C364.606 233.001 367.636 236.248 369.045 237.549C366.637 237.28 361.202 236.084 358.732 233.454C358.608 234.32 358.639 236.41 359.754 237.837C361.148 239.621 344.588 231.268 341.882 225.092C339.175 218.915 331.486 223.604 328.326 222.635C328.826 225.164 328.262 232.031 322.001 239.259C315.741 246.488 311.634 249.18 310.363 249.623Z" fill="#2A2D31"/>
<path d="M370.899 169.823C366.375 162.831 354.619 163.823 349.307 165.708C354.105 165.235 364.627 165.397 368.329 169.822C369.468 171.184 370.919 172.701 372.537 174.192C379.125 180.265 383.208 188.473 384.781 189.615C386.326 190.737 380.187 180.03 381.696 180.76C384.019 181.884 386.188 182.406 387.865 181.903C391.978 180.669 390.436 175.991 388.379 173.42C388.894 174.106 389.613 176.197 388.379 179.076C386.837 182.674 376.555 178.563 370.899 169.823Z" fill="white" fillOpacity="0.15"/>
<path d="M414.124 207.271C413.478 200.131 400.928 197.85 394.734 197.602C397.158 199.337 409.276 201.321 411.7 207.271C414.935 215.212 407.734 212.5 409.35 219.194C410.643 224.55 417.355 223.821 419.412 220.737C416.327 222.279 411.965 223.955 410.672 219.194C409.644 214.053 414.932 216.197 414.124 207.271Z" fill="white" fillOpacity="0.15"/>
<path d="M290.383 196.573C292.063 189.603 304.811 189.175 310.975 189.832C308.324 191.196 296.046 191.392 292.781 196.926C288.424 204.311 299.983 208.513 297.409 214.901C295.35 220.011 287.872 221.014 283.501 221.123C286.54 220.818 293.111 219.079 295.084 214.558C297.549 208.906 288.283 205.286 290.383 196.573Z" fill="white" fillOpacity="0.15"/>
<path d="M307.362 235.853C316.019 236.577 318.368 225.896 318.46 220.465C317.721 223.985 315.353 231.508 311.801 233.439C308.25 235.37 303.108 234.542 300.98 233.887C302.576 234.887 304.662 235.627 307.362 235.853Z" fill="white" fillOpacity="0.15"/>
<path d="M346.897 202.984C345.876 215.228 353.563 226.594 357.534 230.747C352.091 227.521 348.738 221.062 346.897 215.496C346.391 213.966 344.97 222.288 344.68 220.978C344.442 219.902 346.222 213.583 345.709 208.64C345.709 206.362 346.33 203.815 346.897 202.984Z" fill="white" fillOpacity="0.15"/>
<path d="M379.641 207.612C379.23 203.087 371.587 196.472 367.816 193.73C375.528 201.442 377.585 206.069 378.099 210.182C378.51 213.473 381.869 220.464 384.268 224.063C382.897 220.464 380.052 212.136 379.641 207.612Z" fill="white" fillOpacity="0.15"/>
<path d="M342.169 344.901C342.293 340.96 346.243 338.358 348.202 337.55C348.944 338.54 349.717 341.02 346.869 343.019C344.022 345.018 342.482 347.232 342.069 348.089L342.169 344.901Z" fill="black" fillOpacity="0.2"/>
<path d="M366.817 271.419C364.072 275.684 362.532 278.536 359.942 277.874C358.24 276.66 359.989 276.406 353.198 270.99C346.407 265.575 334.281 263.78 329.066 263.559C334.953 260.844 353.581 258.82 358.751 260.433C363.921 262.046 369.562 267.155 366.817 271.419Z" fill="black" fillOpacity="0.2"/>
<path d="M385.333 282.15C385.95 281.009 387.927 277.901 391.758 275.992C395.589 274.082 398.974 274.462 403.583 275.478C407.27 276.29 411.8 279.889 412.917 281.278" stroke="black" strokeWidth="0.6"/>
<path d="M398.846 276.775C393.978 276.622 390.146 279.788 388.848 281.101C389.114 281.883 391.885 284.155 395.123 284.489C399.171 284.907 401.226 284.101 404.74 283.052C407.551 282.212 408.649 281.725 409.422 281.749C407.34 280.33 403.715 276.928 398.846 276.775Z" stroke="black" strokeWidth="0.9"/>
<path d="M341.235 273.226C335.2 273.275 330.693 276.393 329.488 277.805C330.156 278.11 332.232 279.092 335.202 280.577C338.915 282.435 347.355 281.54 349.691 281.034C351.56 280.628 354.283 280.642 355.925 280.7C352.684 278.559 350.229 273.152 341.235 273.226Z" stroke="black" strokeWidth="0.8"/>
<path d="M353.491 278.583L353.466 278.559C352.035 278.971 352.368 280.158 352.713 280.701C353.895 280.652 355.06 280.67 355.926 280.701C355.103 280.158 354.332 279.404 353.491 278.583Z" stroke="black" strokeWidth="0.8"/>
<path d="M359.326 279.013C357.564 276.638 352.63 272.438 347.683 271.105C342.915 269.822 337.26 270.487 334.027 271.836C330.794 273.184 324.807 279.088 321.891 279.576" stroke="black" strokeWidth="0.6"/>
<path d="M348.092 341.029C350.703 341.014 356.89 339.798 360.643 338.524C365.334 336.931 369.12 336.47 371.718 336.842C374.317 337.214 375.467 337.541 377.804 337.034C380.14 336.526 381.861 337.159 386.461 338.465C389.567 339.347 392.157 339.806 392.66 339.804C392.678 339.787 392.697 339.771 392.715 339.755C392.775 339.787 392.753 339.803 392.66 339.804C387.915 343.973 384.392 346.467 379.513 347.238C373.391 348.205 368.502 346.891 362.19 344.662C357.141 342.879 349.812 341.662 348.092 341.029Z" fill="#BFC0C1" stroke="black" strokeWidth="0.5"/>
<path d="M413.123 256.341C414.722 260.839 417.908 270.183 417.864 271.574C417.81 273.312 415.898 278.763 416.087 281.96C416.277 285.157 418.501 297.409 416.797 305.477C415.093 313.545 407.623 330.429 405.638 338.198C403.653 345.967 399.425 359.752 394.823 367.729C390.221 375.706 387.285 381.634 378.39 383.954C369.494 386.275 355.769 383.44 341.888 377.785C329.511 372.742 311.007 359.344 309.051 356.962" stroke="#2A2D31" strokeWidth="0.6"/>
<path d="M375.74 347.405C370.147 348.157 365.285 345.423 362.593 344.952C365.276 345.713 370.163 349.493 375.929 350.602C383.137 351.989 379.596 357.376 379.17 361.938C378.837 365.51 380.457 367.273 377.122 370.608C373.787 373.943 364.347 378.257 356.704 377.459C341.41 375.861 315.777 362.687 311.446 358.973C319.531 366.552 338.919 376.55 340.347 377.272C352.686 381.899 361.425 383.909 367.595 384.469C374.792 385.124 385.186 384.326 390.849 374.557C402.226 354.931 405.552 339.417 407.201 333.087C408.851 326.758 416.362 310.106 417.152 303.46C417.931 296.901 416.814 287.741 416.342 283.863L416.323 283.709C415.862 279.924 416.207 278.194 417.176 275.034C418.146 271.874 417.893 270.706 417.368 268.949C416.948 267.543 414.364 259.959 413.124 256.343L411.015 249.605C411.256 251.16 411.891 254.97 412.499 257.773C413.258 261.278 414.018 264.783 408.857 262.88C403.696 260.977 399.874 262.597 391.687 264.66C383.501 266.723 379.597 270.951 379.17 275.288C378.744 279.625 382.214 294.263 385.257 303.09C388.175 311.552 387.329 320.025 387.909 319.318C388.645 318.422 391.419 316.999 391.189 312.94C391.031 310.143 389.044 306.326 387.143 301.511C385.202 296.596 383.645 289.971 383.179 286.147C382.257 278.576 385.799 276.657 387.909 274.113C390.02 271.569 392.664 270.492 397.59 270.647C401.301 270.764 412.188 267.626 413.238 271.14C414.288 274.654 410.402 278.302 411.714 282.694C413.026 287.087 413.923 286.245 415.189 292.086C416.456 297.927 415.087 304.555 413.736 310.604C412.386 316.653 407.35 319.975 403.428 324.782C401.847 326.72 397.914 325.509 396.369 323.776C395.149 322.407 393.631 321.494 391.805 321.226C386.821 320.493 381.5 321.226 375.74 321.226C370.554 321.226 365.656 321.734 361.804 321.226C368.939 324.931 373.03 329.49 373.546 331.536C374.061 333.583 376.372 335.59 378.11 335.645C379.849 335.699 381.077 336.539 380.393 337.927C378.844 341.069 372.173 340.911 369.575 340.54C366.976 340.168 359.976 341.397 362.593 341.19C365.21 340.982 376.109 343.385 378.11 344.318L378.122 344.323C380.121 345.255 382.718 346.466 375.74 347.405Z" fill="#2A2D31" fillOpacity="0.3"/>
<mask id="mask1" maskType="alpha" maskUnits="userSpaceOnUse" x="388" y="275" width="24" height="11">
<path d="M398.846 276.779C393.978 276.626 390.146 279.792 388.848 281.105C389.114 281.887 391.885 284.159 395.123 284.493C399.171 284.911 400.928 284.386 404.441 283.336C407.252 282.497 408.649 281.728 409.422 281.753C407.34 280.334 403.715 276.932 398.846 276.779Z" fill="#C4C4C4" stroke="black"/>
</mask>
<g mask="url(#mask1)">
<circle cx="397.56" cy="280.8" r="4.42861" transform="rotate(1.80298 397.56 280.8)" fill="black" fillOpacity="0.6" stroke="black"/>
<circle cx="397.56" cy="280.803" r="1.52943" transform="rotate(1.80298 397.56 280.803)" fill="black" stroke="black"/>
</g>
<mask id="mask2" maskType="alpha" maskUnits="userSpaceOnUse" x="328" y="272" width="31" height="11">
<path d="M341.235 273.227C335.2 273.276 330.693 276.394 329.488 277.806C330.156 278.111 332.232 279.093 335.202 280.578C338.915 282.436 347.355 281.541 349.691 281.035C351.56 280.629 355.311 280.643 356.953 280.701C354.032 278.289 350.229 273.153 341.235 273.227Z" fill="#C4C4C4" stroke="black"/>
</mask>
<g mask="url(#mask2)">
<circle cx="340.818" cy="277.273" r="4.42861" transform="rotate(1.80298 340.818 277.273)" fill="black" fillOpacity="0.6" stroke="black"/>
<circle cx="340.818" cy="277.272" r="1.52943" transform="rotate(1.80298 340.818 277.272)" fill="black" stroke="black"/>
</g>
<path d="M347.504 341.291C350.296 341.669 356.581 342.273 359.385 341.665C362.89 340.906 368.423 340.209 371.013 340.871C373.602 341.533 376.79 341.633 378.846 340.828C380.901 340.022 384.379 340.132 386.407 340.196C388.03 340.247 391.744 339.911 392.716 339.748" stroke="black" strokeWidth="0.5"/>
<path d="M327.709 288.176L360.18 261.504C362.035 262.2 362.306 262.374 363.369 263.533L329.738 291.655C328.869 290.206 328.482 289.819 327.709 288.176Z" fill="white" fillOpacity="0.6"/>
<path d="M326.258 284.407L356.119 260.055C357.975 260.75 356.506 259.477 357.569 260.637L326.837 286.436C325.967 284.987 327.031 286.05 326.258 284.407Z" fill="white" fillOpacity="0.6"/>
<mask id="path-53-inside-1" fill="white">
<path fillRule="evenodd" clipRule="evenodd" d="M347.447 301.098C360.123 300.666 370.664 289.665 370.269 278.057C370.075 272.374 369.302 266.629 365.172 262.982C360.865 259.18 353.071 257.6 346.601 257.821C341.199 258.005 335.621 258.687 331.797 261.68C326.65 265.711 324.16 273.57 324.387 280.231C324.783 291.84 334.772 301.53 347.447 301.098ZM347.437 299.891C359.508 299.479 369.55 289.091 369.176 278.132C368.993 272.767 368.259 267.343 364.327 263.901C360.227 260.313 352.805 258.824 346.643 259.034C341.499 259.21 336.187 259.854 332.545 262.682C327.642 266.489 325.269 273.909 325.484 280.197C325.857 291.156 335.366 300.302 347.437 299.891Z"/>
</mask>
<path fillRule="evenodd" clipRule="evenodd" d="M347.447 301.098C360.123 300.666 370.664 289.665 370.269 278.057C370.075 272.374 369.302 266.629 365.172 262.982C360.865 259.18 353.071 257.6 346.601 257.821C341.199 258.005 335.621 258.687 331.797 261.68C326.65 265.711 324.16 273.57 324.387 280.231C324.783 291.84 334.772 301.53 347.447 301.098ZM347.437 299.891C359.508 299.479 369.55 289.091 369.176 278.132C368.993 272.767 368.259 267.343 364.327 263.901C360.227 260.313 352.805 258.824 346.643 259.034C341.499 259.21 336.187 259.854 332.545 262.682C327.642 266.489 325.269 273.909 325.484 280.197C325.857 291.156 335.366 300.302 347.437 299.891Z" fill="#C4C4C4"/>
<path d="M370.269 278.057L369.269 278.091L370.269 278.057ZM347.447 301.098L347.481 302.097L347.447 301.098ZM365.172 262.982L364.51 263.732V263.732L365.172 262.982ZM346.601 257.821L346.635 258.82L346.601 257.821ZM331.797 261.68L331.181 260.893L331.797 261.68ZM324.387 280.231L323.388 280.265L324.387 280.231ZM369.176 278.132L368.176 278.166L369.176 278.132ZM347.437 299.891L347.403 298.891L347.437 299.891ZM364.327 263.901L363.668 264.654L364.327 263.901ZM346.643 259.034L346.677 260.034L346.643 259.034ZM332.545 262.682L333.159 263.472V263.472L332.545 262.682ZM325.484 280.197L324.484 280.232L325.484 280.197ZM369.269 278.091C369.645 289.102 359.582 299.683 347.413 300.098L347.481 302.097C360.663 301.648 371.684 290.228 371.268 278.023L369.269 278.091ZM364.51 263.732C368.289 267.068 369.075 272.397 369.269 278.091L371.268 278.023C371.075 272.351 370.315 266.189 365.834 262.232L364.51 263.732ZM346.635 258.82C349.782 258.713 353.253 259.044 356.45 259.862C359.658 260.682 362.518 261.973 364.51 263.732L365.834 262.232C363.52 260.189 360.329 258.789 356.946 257.924C353.551 257.056 349.89 256.708 346.567 256.822L346.635 258.82ZM332.414 262.468C335.956 259.694 341.227 259.005 346.635 258.82L346.567 256.822C341.171 257.006 335.285 257.679 331.181 260.893L332.414 262.468ZM325.387 280.197C325.166 273.731 327.602 266.236 332.414 262.468L331.181 260.893C325.698 265.187 323.154 273.41 323.388 280.265L325.387 280.197ZM347.413 300.098C335.28 300.512 325.763 291.244 325.387 280.197L323.388 280.265C323.803 292.435 334.263 302.548 347.481 302.097L347.413 300.098ZM368.176 278.166C368.53 288.52 358.976 298.496 347.403 298.891L347.471 300.89C360.04 300.461 370.57 289.661 370.175 278.098L368.176 278.166ZM363.668 264.654C367.246 267.785 367.993 272.791 368.176 278.166L370.175 278.098C369.993 272.743 369.271 266.9 364.986 263.149L363.668 264.654ZM346.677 260.034C349.671 259.931 352.973 260.243 356.013 261.013C359.064 261.785 361.779 263.001 363.668 264.654L364.986 263.149C362.774 261.213 359.729 259.89 356.504 259.074C353.268 258.254 349.777 257.927 346.609 258.035L346.677 260.034ZM333.159 263.472C336.52 260.862 341.526 260.209 346.677 260.034L346.609 258.035C341.472 258.21 335.854 258.847 331.932 261.892L333.159 263.472ZM326.483 280.163C326.275 274.073 328.593 267.017 333.159 263.472L331.932 261.892C326.692 265.961 324.263 273.745 324.484 280.232L326.483 280.163ZM347.403 298.891C335.867 299.285 326.837 290.553 326.483 280.163L324.484 280.232C324.877 291.76 334.866 301.32 347.471 300.89L347.403 298.891Z" fill="black" mask="url(#path-53-inside-1)"/>
<path fillRule="evenodd" clipRule="evenodd" d="M347.4 303.745C360.032 303.334 370.538 292.888 370.143 281.865C369.95 276.468 369.18 271.012 365.064 267.549C360.772 263.938 353.005 262.439 346.557 262.648C341.174 262.823 335.615 263.47 331.805 266.313C326.675 270.141 324.194 277.604 324.42 283.93C324.815 294.953 334.769 304.155 347.4 303.745ZM347.391 302.598C359.42 302.207 369.427 292.342 369.054 281.936C368.872 276.841 368.14 271.69 364.222 268.422C360.136 265.014 352.74 263.6 346.6 263.8C341.473 263.967 336.179 264.579 332.551 267.264C327.665 270.879 325.3 277.926 325.513 283.897C325.886 294.304 335.362 302.989 347.391 302.598Z" fill="#2A2D31" fillOpacity="0.1"/>
<mask id="mask3" maskType="alpha" maskUnits="userSpaceOnUse" x="380" y="264" width="39" height="41">
<path fillRule="evenodd" clipRule="evenodd" d="M399.677 304.983C409.959 304.581 418.511 294.34 418.189 283.533C418.032 278.243 417.405 272.894 414.055 269.499C410.562 265.959 404.239 264.489 398.99 264.695C394.608 264.866 390.083 265.501 386.982 268.288C382.806 272.04 380.786 279.356 380.971 285.558C381.292 296.364 389.394 305.386 399.677 304.983ZM399.669 303.862C409.46 303.479 417.606 293.808 417.303 283.606C417.155 278.611 416.559 273.562 413.37 270.358C410.044 267.017 404.023 265.631 399.025 265.827C394.852 265.99 390.542 266.591 387.588 269.223C383.611 272.767 381.686 279.675 381.86 285.529C382.163 295.731 389.877 304.245 399.669 303.862Z" fill="#2A2D31" fillOpacity="0.3"/>
</mask>
<g mask="url(#mask3)">
<path d="M385.295 295.923L387.351 301.467L392.493 307.011L407.402 310.539L415.628 295.923L415.114 292.395L385.295 295.923Z" fill="#C4C4C4"/>
</g>
<path d="M384.531 293.106L414.103 267.883C415.958 268.579 415.069 269.332 416.132 270.492L386.271 295.425C383.719 293.802 385.304 294.749 384.531 293.106Z" fill="white" fillOpacity="0.6"/>
<path d="M382.793 288.462L411.495 265.559C412.075 265.849 411.785 265.849 412.655 266.428L383.373 290.202C382.793 289.042 383.373 290.202 382.793 288.462Z" fill="white" fillOpacity="0.6"/>
<path d="M320.573 269.768C321.961 269.665 324.482 270.167 326.149 270.431L325.667 272.372C323.228 272.519 321.498 272.52 320.573 272.588C319.648 272.657 313.589 272.236 311.758 272.372L311.171 271.99L293.211 273.168L293.414 271.99L311.171 270.905L311.896 270.327C313.824 270.183 319.185 269.871 320.573 269.768Z" fill="black"/>
<path d="M320.997 278.652C322.372 278.867 323.229 277.972 324.927 277.745L325.967 275.555C323.546 275.22 322.256 275.261 321.34 275.118C320.423 274.974 314.314 275.126 312.5 274.841L311.868 275.283L294.056 272.691L294.116 274.18L311.736 276.643L312.391 277.413C314.301 277.712 319.623 278.436 320.997 278.652Z" fill="#2A2D31" fillOpacity="0.1"/>
<path fillRule="evenodd" clipRule="evenodd" d="M400.231 302.99C410.806 302.64 419.547 292.15 419.157 281.024C418.966 275.578 418.291 270.068 414.826 266.553C411.213 262.887 404.7 261.335 399.302 261.514C394.795 261.663 390.143 262.289 386.968 265.138C382.693 268.975 380.656 276.494 380.88 282.879C381.27 294.005 389.655 303.341 400.231 302.99ZM400.193 302.013C410.257 301.679 418.575 291.716 418.204 281.148C418.023 275.975 417.382 270.741 414.084 267.403C410.646 263.921 404.449 262.447 399.312 262.618C395.023 262.76 390.596 263.354 387.575 266.061C383.507 269.706 381.567 276.848 381.78 282.912C382.15 293.48 390.129 302.347 400.193 302.013Z" fill="black"/>
<path d="M370.036 274.553L369.734 272.815C370.12 272.805 371.487 271.942 374.965 271.652C378.234 271.378 380.549 272.569 382.503 273.39L381.923 275.129C379.271 273.456 377.863 273.038 375.255 273.104C373.168 273.157 370.7 274.053 370.036 274.553Z" fill="black"/>
<path d="M370.036 277.639L369.734 275.901C370.12 275.891 371.487 275.028 374.965 274.738C378.234 274.464 380.549 275.655 382.503 276.476L381.923 278.215C379.271 276.542 377.863 276.124 375.255 276.19C373.168 276.243 370.7 277.139 370.036 277.639Z" fill="#2A2D31" fillOpacity="0.1"/>
<g opacity="0.8">
<circle cx="386" cy="352" r="0.5" transform="rotate(-180 386 352)" fill="#2A2D31"/>
<circle cx="370" cy="352" r="0.5" transform="rotate(-180 370 352)" fill="#2A2D31"/>
<circle cx="374" cy="352" r="0.5" transform="rotate(-180 374 352)" fill="#2A2D31"/>
<circle cx="378" cy="352" r="0.5" transform="rotate(-180 378 352)" fill="#2A2D31"/>
<circle cx="382" cy="352" r="0.5" transform="rotate(-180 382 352)" fill="#2A2D31"/>
<circle cx="366" cy="352" r="0.5" transform="rotate(-180 366 352)" fill="#2A2D31"/>
<circle cx="362" cy="352" r="0.5" transform="rotate(-180 362 352)" fill="#2A2D31"/>
<circle cx="374" cy="355" r="1" fill="#2A2D31"/>
<circle cx="378" cy="355" r="1" fill="#2A2D31"/>
<circle cx="382" cy="355" r="0.5" transform="rotate(-180 382 355)" fill="#2A2D31"/>
<circle cx="370" cy="355" r="1" fill="#2A2D31"/>
<circle cx="366" cy="355" r="0.5" transform="rotate(-180 366 355)" fill="#2A2D31"/>
<circle cx="374" cy="358" r="1" fill="#2A2D31"/>
<circle cx="374" cy="361" r="0.5" transform="rotate(-180 374 361)" fill="#2A2D31"/>
<circle cx="378" cy="358" r="0.5" transform="rotate(-180 378 358)" fill="#2A2D31"/>
<circle cx="370" cy="358" r="0.5" transform="rotate(-180 370 358)" fill="#2A2D31"/>
<circle cx="372" cy="356.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 372 359.5)" fill="#2A2D31"/>
<circle cx="376" cy="356.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376 359.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="381.5" r="0.5" transform="rotate(-180 372.5 381.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="378.5" r="0.5" transform="rotate(-180 372.5 378.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="375.5" r="0.5" transform="rotate(-180 372.5 375.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="372.5" r="0.5" transform="rotate(-180 372.5 372.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="369.5" r="0.5" transform="rotate(-180 372.5 369.5)" fill="#2A2D31"/>
<circle cx="372.5" cy="366.5" r="0.5" transform="rotate(-180 372.5 366.5)" fill="#2A2D31"/>
<circle cx="380.5" cy="378.5" r="0.5" transform="rotate(-180 380.5 378.5)" fill="#2A2D31"/>
<circle cx="380.5" cy="375.5" r="0.5" transform="rotate(-180 380.5 375.5)" fill="#2A2D31"/>
<circle cx="380.5" cy="372.5" r="0.5" transform="rotate(-180 380.5 372.5)" fill="#2A2D31"/>
<circle cx="380.5" cy="369.5" r="0.5" transform="rotate(-180 380.5 369.5)" fill="#2A2D31"/>
<circle cx="368.5" cy="378.5" r="0.5" transform="rotate(-180 368.5 378.5)" fill="#2A2D31"/>
<circle cx="368.5" cy="375.5" r="0.5" transform="rotate(-180 368.5 375.5)" fill="#2A2D31"/>
<circle cx="368.5" cy="372.5" r="0.5" transform="rotate(-180 368.5 372.5)" fill="#2A2D31"/>
<circle cx="368.5" cy="369.5" r="0.5" transform="rotate(-180 368.5 369.5)" fill="#2A2D31"/>
<circle cx="364.5" cy="378.5" r="0.5" transform="rotate(-180 364.5 378.5)" fill="#2A2D31"/>
<circle cx="364.5" cy="375.5" r="0.5" transform="rotate(-180 364.5 375.5)" fill="#2A2D31"/>
<circle cx="364.5" cy="372.5" r="0.5" transform="rotate(-180 364.5 372.5)" fill="#2A2D31"/>
<circle cx="360.5" cy="378.5" r="0.5" transform="rotate(-180 360.5 378.5)" fill="#2A2D31"/>
<circle cx="360.5" cy="375.5" r="0.5" transform="rotate(-180 360.5 375.5)" fill="#2A2D31"/>
<circle cx="360.5" cy="372.5" r="0.5" transform="rotate(-180 360.5 372.5)" fill="#2A2D31"/>
<circle cx="356.5" cy="378.5" r="0.5" transform="rotate(-180 356.5 378.5)" fill="#2A2D31"/>
<circle cx="356.5" cy="375.5" r="0.5" transform="rotate(-180 356.5 375.5)" fill="#2A2D31"/>
<circle cx="352.5" cy="378.5" r="0.5" transform="rotate(-180 352.5 378.5)" fill="#2A2D31"/>
<circle cx="348.5" cy="378.5" r="0.5" transform="rotate(-180 348.5 378.5)" fill="#2A2D31"/>
<circle cx="352.5" cy="375.5" r="0.5" transform="rotate(-180 352.5 375.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="375.5" r="0.5" transform="rotate(-180 344.5 375.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="372.5" r="0.5" transform="rotate(-180 344.5 372.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="369.5" r="0.5" transform="rotate(-180 344.5 369.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="366.5" r="0.5" transform="rotate(-180 344.5 366.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="363.5" r="0.5" transform="rotate(-180 344.5 363.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="360" r="0.5" transform="rotate(-180 344.5 360)" fill="#2A2D31"/>
<circle cx="344.5" cy="356.5" r="0.5" transform="rotate(-180 344.5 356.5)" fill="#2A2D31"/>
<circle cx="344.5" cy="353.5" r="0.5" transform="rotate(-180 344.5 353.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="375.5" r="0.5" transform="rotate(-180 340.5 375.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="372.5" r="0.5" transform="rotate(-180 340.5 372.5)" fill="#2A2D31"/>
<circle cx="336.5" cy="372.5" r="0.5" transform="rotate(-180 336.5 372.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="369.5" r="0.5" transform="rotate(-180 340.5 369.5)" fill="#2A2D31"/>
<circle cx="336.5" cy="369.5" r="0.5" transform="rotate(-180 336.5 369.5)" fill="#2A2D31"/>
<circle cx="332.5" cy="369.5" r="0.5" transform="rotate(-180 332.5 369.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="366.5" r="0.5" transform="rotate(-180 340.5 366.5)" fill="#2A2D31"/>
<circle cx="336.5" cy="366.5" r="0.5" transform="rotate(-180 336.5 366.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="363.5" r="0.5" transform="rotate(-180 340.5 363.5)" fill="#2A2D31"/>
<circle cx="336.5" cy="363.5" r="0.5" transform="rotate(-180 336.5 363.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="360" r="0.5" transform="rotate(-180 340.5 360)" fill="#2A2D31"/>
<circle cx="340.5" cy="356.5" r="0.5" transform="rotate(-180 340.5 356.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="353.5" r="0.5" transform="rotate(-180 340.5 353.5)" fill="#2A2D31"/>
<circle cx="340.5" cy="350.5" r="0.5" transform="rotate(-180 340.5 350.5)" fill="#2A2D31"/>
<circle cx="348.5" cy="375.5" r="0.5" transform="rotate(-180 348.5 375.5)" fill="#2A2D31"/>
<circle cx="348.5" cy="372.5" r="0.5" transform="rotate(-180 348.5 372.5)" fill="#2A2D31"/>
<circle cx="352.5" cy="372.5" r="0.5" transform="rotate(-180 352.5 372.5)" fill="#2A2D31"/>
<circle cx="348.5" cy="369.5" r="0.5" transform="rotate(-180 348.5 369.5)" fill="#2A2D31"/>
<circle cx="348.5" cy="366.5" r="0.5" transform="rotate(-180 348.5 366.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 366.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 366.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 366.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 366.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 362.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 362.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 362.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 358.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 358.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 358.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 354.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 350.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 350.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 365)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 361.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 365)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 361.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 358)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 355)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 352)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 349)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 361.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 358)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 355)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 352)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 349)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 334.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 365)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 338.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 334.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 354.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 350.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 354.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 350.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 346.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 342.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 370.5 383)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 366.5 383)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 362.5 383)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 368.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 364.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 360.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 356.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 374.5 383)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 378.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 378.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 378.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 378.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 378.5 368)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 382.5 380)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 382.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 382.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 382.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 386.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 390.5 374)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 386.5 377)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 380.5 381.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 378.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 375.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 372.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 369.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 376.5 366.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 384.5 378.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 384.5 375.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 388.5 375.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 384.5 372.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 388.5 372.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 390.5 371)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 392.5 369.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 380 356.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 368 356.5)" fill="#2A2D31"/>
<circle cx="372" cy="353.5" r="1" fill="#2A2D31"/>
<circle cx="376" cy="353.5" r="1" fill="#2A2D31"/>
<circle cx="380" cy="353.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 384 353.5)" fill="#2A2D31"/>
<circle cx="368" cy="353.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 364 353.5)" fill="#2A2D31"/>
</g>
<g opacity="0.8">
<circle cx="375" cy="327" r="1" fill="#2A2D31"/>
<circle cx="379" cy="327" r="1" fill="#2A2D31"/>
<circle cx="383" cy="327" r="1" fill="#2A2D31"/>
<circle cx="371" cy="327" r="1" fill="#2A2D31"/>
<circle cx="367" cy="327" r="1" fill="#2A2D31"/>
<circle cx="375" cy="330" r="1" fill="#2A2D31"/>
<circle cx="379" cy="330" r="1" fill="#2A2D31"/>
<circle cx="383" cy="330" r="1" fill="#2A2D31"/>
<circle cx="387" cy="330" r="1" fill="#2A2D31"/>
<circle cx="391" cy="330" r="1" fill="#2A2D31"/>
<circle cx="395" cy="330" r="0.5" transform="rotate(-180 395 330)" fill="#2A2D31"/>
<circle cx="371" cy="330" r="1" fill="#2A2D31"/>
<circle cx="367" cy="330" r="1" fill="#2A2D31"/>
<circle cx="363" cy="330" r="1" fill="#2A2D31"/>
<circle cx="359" cy="330" r="1" fill="#2A2D31"/>
<circle cx="355" cy="330" r="1" fill="#2A2D31"/>
<circle cx="351" cy="330" r="1" fill="#2A2D31"/>
<circle cx="347" cy="330" r="0.5" fill="#2A2D31"/>
<circle cx="375" cy="333" r="1" fill="#2A2D31"/>
<circle cx="379" cy="333" r="1" fill="#2A2D31"/>
<circle cx="383" cy="333" r="1" fill="#2A2D31"/>
<circle cx="387" cy="333" r="1" fill="#2A2D31"/>
<circle cx="391" cy="333" r="1" fill="#2A2D31"/>
<circle cx="391" cy="336" r="1" fill="#2A2D31"/>
<circle cx="395" cy="333" r="1" fill="#2A2D31"/>
<circle cx="395" cy="336" r="1" fill="#2A2D31"/>
<circle cx="399" cy="333" r="0.5" transform="rotate(-180 399 333)" fill="#2A2D31"/>
<circle cx="399" cy="336" r="1" fill="#2A2D31"/>
<circle cx="399" cy="339" r="0.5" transform="rotate(-180 399 339)" fill="#2A2D31"/>
<circle cx="395" cy="339" r="0.5" transform="rotate(-180 395 339)" fill="#2A2D31"/>
<circle cx="393" cy="337.5" r="0.5" transform="rotate(-180 393 337.5)" fill="#2A2D31"/>
<circle cx="371" cy="333" r="1" fill="#2A2D31"/>
<circle cx="367" cy="333" r="1" fill="#2A2D31"/>
<circle cx="363" cy="333" r="1" fill="#2A2D31"/>
<circle cx="359" cy="333" r="1" fill="#2A2D31"/>
<circle cx="355" cy="333" r="1" fill="#2A2D31"/>
<circle cx="355" cy="336" r="1" fill="#2A2D31"/>
<circle cx="351" cy="333" r="1" fill="#2A2D31"/>
<circle cx="351" cy="336" r="1" fill="#2A2D31"/>
<circle cx="347" cy="333" r="1" fill="#2A2D31"/>
<circle cx="347" cy="336" r="1" fill="#2A2D31"/>
<circle cx="347" cy="339" r="1" fill="#2A2D31"/>
<circle cx="343" cy="333" r="0.5" transform="rotate(-180 343 333)" fill="#2A2D31"/>
<circle cx="343" cy="336" r="1" fill="#2A2D31"/>
<circle cx="343" cy="339" r="1" fill="#2A2D31"/>
<circle cx="339" cy="339" r="0.5" fill="#2A2D31"/>
<circle cx="343" cy="342" r="0.5" transform="rotate(-180 343 342)" fill="#2A2D31"/>
<circle cx="339" cy="342" r="0.5" transform="rotate(-180 339 342)" fill="#2A2D31"/>
<circle cx="339" cy="344.5" r="0.5" transform="rotate(-180 339 344.5)" fill="#2A2D31"/>
<circle cx="339" cy="346.5" r="0.5" transform="rotate(-180 339 346.5)" fill="#2A2D31"/>
<circle cx="373" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="377" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="381" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="385" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="389" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="389" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="393" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="393" cy="334.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 331.5)" fill="#2A2D31"/>
<circle cx="397" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="397" cy="337.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 334.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 337.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 340.5)" fill="#2A2D31"/>
<circle cx="399" cy="342" r="0.5" transform="rotate(-180 399 342)" fill="#2A2D31"/>
<circle cx="399" cy="345" r="0.5" transform="rotate(-180 399 345)" fill="#2A2D31"/>
<circle cx="399" cy="348" r="0.5" transform="rotate(-180 399 348)" fill="#2A2D31"/>
<circle cx="399" cy="351" r="0.5" transform="rotate(-180 399 351)" fill="#2A2D31"/>
<circle cx="399" cy="354" r="0.5" transform="rotate(-180 399 354)" fill="#2A2D31"/>
<circle cx="399" cy="357" r="0.5" transform="rotate(-180 399 357)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 340.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 343.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 352.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 400.5 352.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 355.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 358.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 397 361.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 395 363)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 393 367.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 395 366)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 346.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 401 349.5)" fill="#2A2D31"/>
<circle cx="369" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="365" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="361" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="357" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="357" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="361" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="353" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="349" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="349" cy="337.5" r="1" fill="#2A2D31"/>
<circle cx="345" cy="334.5" r="1" fill="#2A2D31"/>
<circle cx="345" cy="337.5" r="1" fill="#2A2D31"/>
<circle cx="345" cy="340.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 341 334.5)" fill="#2A2D31"/>
<circle cx="341" cy="337.5" r="1" fill="#2A2D31"/>
<circle cx="341" cy="340.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 341 343.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 341 345.5)" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 340.5 347.5)" fill="#2A2D31"/>
<circle cx="353" cy="331.5" r="1" fill="#2A2D31"/>
<circle cx="349" cy="331.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 345 331.5)" fill="#2A2D31"/>
<circle cx="373" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="377" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="381" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="385" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="389" cy="328.5" r="1" fill="#2A2D31"/>
<circle r="0.5" transform="matrix(-1 0 0 1 393 328.5)" fill="#2A2D31"/>
<circle cx="369" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="365" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="361" cy="328.5" r="1" fill="#2A2D31"/>
<circle cx="357" cy="328.5" r="1" fill="#2A2D31"/>
</g>
</g>
<g id="triangle_planet">
<path d="M268.927 62.8985C269.596 60.6882 272.407 60.0312 273.987 61.716L291.711 80.6207C293.29 82.3054 292.454 85.0683 290.205 85.5938L264.971 91.4909C262.722 92.0164 260.748 89.9104 261.417 87.7001L268.927 62.8985Z" fill="#2A2D31"/>
<path d="M285.812 74.4759C287.731 73.1124 288.741 71.7462 288.442 70.6304C287.767 68.1129 280.686 67.823 272.625 69.983C264.563 72.143 258.575 75.9349 259.25 78.4524C259.549 79.5682 261.107 80.2465 263.45 80.4677" stroke="#C7D0DC" strokeWidth="2"/>
<path d="M285.812 74.4759C287.782 73.3026 288.858 72.1816 288.63 71.3335C288.118 69.42 281.167 69.6198 273.106 71.7798C265.045 73.9398 258.926 77.242 259.438 79.1555C259.666 80.0036 261.158 80.4366 263.45 80.4677" stroke="#C7D0DC" strokeWidth="2"/>
</g>
<g id="circle_planet"><circle cx="487.732" cy="104.972" r="38.6894" transform="rotate(30 487.732 104.972)" fill="#2A2D31"/>
<path d="M524.808 116.327C529.869 121.968 532.108 126.767 530.451 129.637C526.712 136.114 504.554 130.322 480.96 116.7C457.367 103.078 441.271 86.7851 445.011 80.3084C446.668 77.4377 451.944 76.9773 459.359 78.5406" stroke="#C7D0DC" strokeWidth="2"/>
<path d="M524.808 116.327C529.969 121.794 532.337 126.37 530.821 128.996C527.399 134.923 505.499 128.684 481.906 115.062C458.312 101.44 441.959 85.5937 445.381 79.6676C446.897 77.0409 452.044 76.804 459.359 78.5406" stroke="#C7D0DC" strokeWidth="2"/>
<path d="M524.808 116.327C530.066 121.628 532.558 125.988 531.177 128.38C528.062 133.776 506.409 127.108 482.816 113.486C459.222 99.8641 442.621 84.447 445.737 79.0507C447.118 76.659 452.14 76.6373 459.359 78.5406" stroke="#C7D0DC" strokeWidth="2"/>
</g>
<path d="M193.672 13.2459C193.672 13.9891 183.72 14.667 183.26 15.1804C182.729 15.774 181.957 25.82 181.097 25.82C180.238 25.82 179.466 15.774 178.935 15.1804C178.475 14.667 168.523 13.9891 168.523 13.2459C168.523 12.5027 178.475 11.8248 178.935 11.3114C179.466 10.7178 180.238 0.671875 181.097 0.671875C181.957 0.671875 182.729 10.7178 183.26 11.3114C183.72 11.8248 193.672 12.5027 193.672 13.2459Z" fill="#C7D0DC"/>
<path d="M403.561 17.1153C403.561 17.6298 396.671 18.0991 396.353 18.4545C395.985 18.8655 395.45 25.8204 394.855 25.8204C394.261 25.8204 393.726 18.8655 393.358 18.4545C393.04 18.0991 386.15 17.6298 386.15 17.1153C386.15 16.6008 393.04 16.1314 393.358 15.776C393.726 15.365 394.261 8.41016 394.855 8.41016C395.45 8.41016 395.985 15.365 396.353 15.776C396.671 16.1314 403.561 16.6008 403.561 17.1153Z" fill="#C7D0DC"/>
<path d="M84.3731 291.811C84.3731 292.325 77.4834 292.794 77.1653 293.15C76.7975 293.561 76.263 300.516 75.668 300.516C75.073 300.516 74.5385 293.561 74.1706 293.15C73.8525 292.794 66.9629 292.325 66.9629 291.811C66.9629 291.296 73.8525 290.827 74.1706 290.471C74.5385 290.06 75.073 283.105 75.668 283.105C76.263 283.105 76.7975 290.06 77.1653 290.471C77.4834 290.827 84.3731 291.296 84.3731 291.811Z" fill="#C7D0DC"/>
<path d="M645.369 115.773C645.369 116.516 635.417 117.194 634.958 117.708C634.426 118.301 633.654 128.347 632.795 128.347C631.935 128.347 631.163 118.301 630.632 117.708C630.172 117.194 620.221 116.516 620.221 115.773C620.221 115.03 630.172 114.352 630.632 113.839C631.163 113.245 631.935 103.199 632.795 103.199C633.654 103.199 634.426 113.245 634.958 113.839C635.417 114.352 645.369 115.03 645.369 115.773Z" fill="#C7D0DC"/>
<defs>
<linearGradient id="paint0_linear" x1="326" y1="308.5" x2="324" y2="349" gradientUnits="userSpaceOnUse">
<stop stopColor="#EAEAEA"/>
<stop offset="1" stopColor="#EAEAEA" stopOpacity="0"/>
</linearGradient>
</defs>
</svg>
);